// <auto-generated>
//   Generated from packages/contracts/openapi/openapi.json by tools/scripts/generate-clients.ts.
//   Do not edit: run `pnpm generate` and commit the result. CI fails on a difference (#36).
// </auto-generated>
/* eslint-disable */
/**
 * `GET /v1/hello` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HELLO = {
    operationId: "getHello",
    method: "GET",
    path: "/v1/hello",
    queryParams: ["cursor", "limit", "name"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/scope-probes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_SCOPE_PROBES = {
    operationId: "listScopeProbes",
    method: "GET",
    path: "/v1/organizations/{organizationId}/scope-probes",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/scope-probes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_SCOPE_PROBE = {
    operationId: "createScopeProbe",
    method: "POST",
    path: "/v1/organizations/{organizationId}/scope-probes",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/scope-probes/{scopeProbeId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SCOPE_PROBE = {
    operationId: "getScopeProbe",
    method: "GET",
    path: "/v1/organizations/{organizationId}/scope-probes/{scopeProbeId}",
    queryParams: [],
    pathParams: ["organizationId", "scopeProbeId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/audit` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_ORGANIZATION_AUDIT = {
    operationId: "listOrganizationAudit",
    method: "GET",
    path: "/v1/organizations/{organizationId}/audit",
    queryParams: ["cursor", "limit", "actorId", "actorKind", "action", "targetType", "targetId", "venueId", "onBehalfOf", "requestId", "from", "to"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/audit/export` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const EXPORT_ORGANIZATION_AUDIT = {
    operationId: "exportOrganizationAudit",
    method: "POST",
    path: "/v1/organizations/{organizationId}/audit/export",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/audit` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLATFORM_AUDIT = {
    operationId: "listPlatformAudit",
    method: "GET",
    path: "/v1/hq/audit",
    queryParams: ["cursor", "limit", "actorId", "actorKind", "action", "targetType", "targetId", "venueId", "onBehalfOf", "requestId", "from", "to", "organizationId", "reason"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/audit/export` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const EXPORT_PLATFORM_AUDIT = {
    operationId: "exportPlatformAudit",
    method: "POST",
    path: "/v1/hq/audit/export",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/phone/code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REQUEST_STATION_PHONE_CODE = {
    operationId: "requestStationPhoneCode",
    method: "POST",
    path: "/v1/station/sign-in/phone/code",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/phone` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_IN_AT_STATION_WITH_PHONE = {
    operationId: "signInAtStationWithPhone",
    method: "POST",
    path: "/v1/station/sign-in/phone",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/password` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_IN_AT_STATION_WITH_PASSWORD = {
    operationId: "signInAtStationWithPassword",
    method: "POST",
    path: "/v1/station/sign-in/password",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/sign-in/options` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_SIGN_IN_OPTIONS = {
    operationId: "getStationSignInOptions",
    method: "GET",
    path: "/v1/station/sign-in/options",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/sign-in/email/code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REQUEST_STATION_EMAIL_CODE = {
    operationId: "requestStationEmailCode",
    method: "POST",
    path: "/v1/station/sign-in/email/code",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/email` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_IN_AT_STATION_WITH_EMAIL = {
    operationId: "signInAtStationWithEmail",
    method: "POST",
    path: "/v1/station/sign-in/email",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/profile` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMPLETE_STATION_PROFILE = {
    operationId: "completeStationProfile",
    method: "POST",
    path: "/v1/station/sign-in/profile",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/profile/email` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const VERIFY_STATION_PROFILE_EMAIL = {
    operationId: "verifyStationProfileEmail",
    method: "POST",
    path: "/v1/station/sign-in/profile/email",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/handoffs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STATION_SIGN_IN_HANDOFF = {
    operationId: "createStationSignInHandoff",
    method: "POST",
    path: "/v1/station/sign-in/handoffs",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/handoffs/{handoffId}/collect` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COLLECT_STATION_SIGN_IN_HANDOFF = {
    operationId: "collectStationSignInHandoff",
    method: "POST",
    path: "/v1/station/sign-in/handoffs/{handoffId}/collect",
    queryParams: [],
    pathParams: ["handoffId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/sign-in/handoffs/{handoffId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_STATION_SIGN_IN_HANDOFF = {
    operationId: "cancelStationSignInHandoff",
    method: "POST",
    path: "/v1/station/sign-in/handoffs/{handoffId}/cancel",
    queryParams: [],
    pathParams: ["handoffId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station-sign-in/lookup` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOOK_UP_SIGN_IN_HANDOFF = {
    operationId: "lookUpSignInHandoff",
    method: "POST",
    path: "/v1/station-sign-in/lookup",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/me/station-sign-in` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CONFIRM_SIGN_IN_HANDOFF = {
    operationId: "confirmSignInHandoff",
    method: "POST",
    path: "/v1/me/station-sign-in",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station-sign-in/end` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const END_SIGN_IN_HANDOFF_SESSION = {
    operationId: "endSignInHandoffSession",
    method: "POST",
    path: "/v1/station-sign-in/end",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/connected-accounts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_CONNECTED_ACCOUNTS = {
    operationId: "getStationConnectedAccounts",
    method: "GET",
    path: "/v1/station/connected-accounts",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/connected-accounts/link-handoffs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STATION_LINK_HANDOFF = {
    operationId: "createStationLinkHandoff",
    method: "POST",
    path: "/v1/station/connected-accounts/link-handoffs",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/connected-accounts/link-handoffs/{handoffId}/collect` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COLLECT_STATION_LINK_HANDOFF = {
    operationId: "collectStationLinkHandoff",
    method: "POST",
    path: "/v1/station/connected-accounts/link-handoffs/{handoffId}/collect",
    queryParams: [],
    pathParams: ["handoffId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/connected-accounts/link-handoffs/{handoffId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_STATION_LINK_HANDOFF = {
    operationId: "cancelStationLinkHandoff",
    method: "POST",
    path: "/v1/station/connected-accounts/link-handoffs/{handoffId}/cancel",
    queryParams: [],
    pathParams: ["handoffId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station-link/lookup` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOOK_UP_STATION_LINK = {
    operationId: "lookUpStationLink",
    method: "POST",
    path: "/v1/station-link/lookup",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_VENUES = {
    operationId: "listVenues",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_VENUE = {
    operationId: "createVenue",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE = {
    operationId: "getVenue",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_VENUE = {
    operationId: "updateVenue",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["if-match"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/archive` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ARCHIVE_VENUE = {
    operationId: "archiveVenue",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/archive",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["if-match"],
    hasBody: false,
};
/**
 * `PATCH /v1/hq/organizations/{organizationId}/venues/{venueId}/listing` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_VENUE_LISTING = {
    operationId: "updateVenueListing",
    method: "PATCH",
    path: "/v1/hq/organizations/{organizationId}/venues/{venueId}/listing",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/venues` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_VENUES = {
    operationId: "listHqVenues",
    method: "GET",
    path: "/v1/hq/venues",
    queryParams: ["cursor", "limit", "organizationId", "q", "city", "status", "publicListing", "featured", "partner", "sponsored"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/franchisees` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_FRANCHISEES = {
    operationId: "listFranchisees",
    method: "GET",
    path: "/v1/organizations/{organizationId}/franchisees",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/franchisees/{franchiseeId}/venues` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_FRANCHISEE_VENUES = {
    operationId: "listFranchiseeVenues",
    method: "GET",
    path: "/v1/organizations/{organizationId}/franchisees/{franchiseeId}/venues",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "franchiseeId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/public/venues` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PUBLIC_VENUES = {
    operationId: "listPublicVenues",
    method: "GET",
    path: "/v1/public/venues",
    queryParams: ["city", "lat", "lng", "radiusKm", "openNow", "amenities", "cursor", "limit"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/public/venues/{slug}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PUBLIC_VENUE = {
    operationId: "getPublicVenue",
    method: "GET",
    path: "/v1/public/venues/{slug}",
    queryParams: [],
    pathParams: ["slug"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/public/venues/{slug}/shop` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PUBLIC_VENUE_SHOP = {
    operationId: "getPublicVenueShop",
    method: "GET",
    path: "/v1/public/venues/{slug}/shop",
    queryParams: [],
    pathParams: ["slug"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/files` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_FILE = {
    operationId: "createFile",
    method: "POST",
    path: "/v1/organizations/{organizationId}/files",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/files/{fileId}/complete` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMPLETE_FILE = {
    operationId: "completeFile",
    method: "POST",
    path: "/v1/organizations/{organizationId}/files/{fileId}/complete",
    queryParams: [],
    pathParams: ["organizationId", "fileId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/files/{fileId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_FILE = {
    operationId: "getFile",
    method: "GET",
    path: "/v1/organizations/{organizationId}/files/{fileId}",
    queryParams: [],
    pathParams: ["organizationId", "fileId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/station-classes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STATION_CLASSES = {
    operationId: "listStationClasses",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/station-classes",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/station-classes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STATION_CLASS = {
    operationId: "createStationClass",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/station-classes",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/station-classes/{classId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_STATION_CLASS = {
    operationId: "updateStationClass",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/station-classes/{classId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "classId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/zones` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_ZONES = {
    operationId: "listZones",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/zones",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/zones` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_ZONE = {
    operationId: "createZone",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/zones",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/zones/{zoneId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_ZONE = {
    operationId: "updateZone",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/zones/{zoneId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "zoneId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/floor-plan` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_FLOOR_PLAN = {
    operationId: "getFloorPlan",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/floor-plan",
    queryParams: ["floor"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/floor-plan` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_FLOOR_PLAN = {
    operationId: "putFloorPlan",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/floor-plan",
    queryParams: ["floor"],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["if-match"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STATIONS = {
    operationId: "listStations",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STATION = {
    operationId: "createStation",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_STATION = {
    operationId: "updateStation",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/unpair` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNPAIR_STATION = {
    operationId: "unpairStation",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/unpair",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: ["idempotency-key"],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/remove` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REMOVE_STATION = {
    operationId: "removeStation",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/remove",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: ["idempotency-key"],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/display` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_DISPLAY = {
    operationId: "getStationDisplay",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/display",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/display` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STATION_DISPLAY = {
    operationId: "createStationDisplay",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/display",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/display` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REVOKE_STATION_DISPLAY = {
    operationId: "revokeStationDisplay",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/display",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/public/displays/{token}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PUBLIC_DISPLAY = {
    operationId: "getPublicDisplay",
    method: "GET",
    path: "/v1/public/displays/{token}",
    queryParams: [],
    pathParams: ["token"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/public/displays/{token}/realtime-token` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_PUBLIC_DISPLAY_REALTIME_TOKEN = {
    operationId: "createPublicDisplayRealtimeToken",
    method: "POST",
    path: "/v1/public/displays/{token}/realtime-token",
    queryParams: [],
    pathParams: ["token"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/floor` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_FLOOR = {
    operationId: "getFloor",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/floor",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/power` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const STATION_POWER = {
    operationId: "stationPower",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/power",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/lock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOCK_STATION = {
    operationId: "lockStation",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/lock",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/maintenance` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_STATION_MAINTENANCE = {
    operationId: "setStationMaintenance",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/maintenance",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/message` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MESSAGE_STATION = {
    operationId: "messageStation",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/message",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/setup/skip` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SKIP_STATION_SETUP = {
    operationId: "skipStationSetup",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/setup/skip",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/offline-codes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GENERATE_OFFLINE_CODE = {
    operationId: "generateOfflineCode",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/offline-codes",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/device-pairings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_DEVICE_PAIRING = {
    operationId: "createDevicePairing",
    method: "POST",
    path: "/v1/device-pairings",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/device-pairings/{code}/approve` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const APPROVE_DEVICE_PAIRING = {
    operationId: "approveDevicePairing",
    method: "POST",
    path: "/v1/organizations/{organizationId}/device-pairings/{code}/approve",
    queryParams: [],
    pathParams: ["organizationId", "code"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/device-pairings/{pairingId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_DEVICE_PAIRING = {
    operationId: "getDevicePairing",
    method: "GET",
    path: "/v1/device-pairings/{pairingId}",
    queryParams: [],
    pathParams: ["pairingId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PLATFORM_SETTINGS = {
    operationId: "getPlatformSettings",
    method: "GET",
    path: "/v1/hq/settings",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_PLATFORM_SETTINGS = {
    operationId: "putPlatformSettings",
    method: "PUT",
    path: "/v1/hq/settings",
    queryParams: [],
    pathParams: [],
    headerParams: ["if-match"],
    hasBody: true,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_ORGANIZATION_SETTINGS = {
    operationId: "getHqOrganizationSettings",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/settings",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/organizations/{organizationId}/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_HQ_ORGANIZATION_SETTINGS = {
    operationId: "putHqOrganizationSettings",
    method: "PUT",
    path: "/v1/hq/organizations/{organizationId}/settings",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: ["if-match"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ORGANIZATION_SETTINGS = {
    operationId: "getOrganizationSettings",
    method: "GET",
    path: "/v1/organizations/{organizationId}/settings",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_ORGANIZATION_SETTINGS = {
    operationId: "putOrganizationSettings",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/settings",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: ["if-match"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE_SETTINGS = {
    operationId: "getVenueSettings",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/settings",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/settings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_VENUE_SETTINGS = {
    operationId: "putVenueSettings",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/settings",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["if-match"],
    hasBody: true,
};
/**
 * `GET /v1/me` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ME = {
    operationId: "getMe",
    method: "GET",
    path: "/v1/me",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/me` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_ME = {
    operationId: "updateMe",
    method: "PATCH",
    path: "/v1/me",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/me/profile/complete` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMPLETE_MY_PROFILE = {
    operationId: "completeMyProfile",
    method: "POST",
    path: "/v1/me/profile/complete",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/me/consents` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_CONSENTS = {
    operationId: "getMyConsents",
    method: "GET",
    path: "/v1/me/consents",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/me/consents` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ACCEPT_CONSENTS = {
    operationId: "acceptConsents",
    method: "POST",
    path: "/v1/me/consents",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/me/demo` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_DEMO = {
    operationId: "getMyDemo",
    method: "GET",
    path: "/v1/me/demo",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/me/demo` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const START_MY_DEMO = {
    operationId: "startMyDemo",
    method: "POST",
    path: "/v1/me/demo",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/notifications/prefs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_NOTIFICATION_PREFS = {
    operationId: "getNotificationPrefs",
    method: "GET",
    path: "/v1/notifications/prefs",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/notifications/prefs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_NOTIFICATION_PREFS = {
    operationId: "putNotificationPrefs",
    method: "PUT",
    path: "/v1/notifications/prefs",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/notifications` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_NOTIFICATIONS = {
    operationId: "listNotifications",
    method: "GET",
    path: "/v1/organizations/{organizationId}/notifications",
    queryParams: ["cursor", "limit", "status"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/notifications/{notificationId}/read` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MARK_NOTIFICATION_READ = {
    operationId: "markNotificationRead",
    method: "POST",
    path: "/v1/organizations/{organizationId}/notifications/{notificationId}/read",
    queryParams: [],
    pathParams: ["organizationId", "notificationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/notifications/read` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MARK_ALL_NOTIFICATIONS_READ = {
    operationId: "markAllNotificationsRead",
    method: "POST",
    path: "/v1/organizations/{organizationId}/notifications/read",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/notification-preferences` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_NOTIFICATION_PREFERENCES = {
    operationId: "getNotificationPreferences",
    method: "GET",
    path: "/v1/organizations/{organizationId}/notification-preferences",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/notification-preferences` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_NOTIFICATION_PREFERENCES = {
    operationId: "putNotificationPreferences",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/notification-preferences",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/members` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MEMBERS = {
    operationId: "listMembers",
    method: "GET",
    path: "/v1/organizations/{organizationId}/members",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/members/{memberId}/role` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CHANGE_MEMBER_ROLE = {
    operationId: "changeMemberRole",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/members/{memberId}/role",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PUT /v1/organizations/{organizationId}/members/{memberId}/venues` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CHANGE_MEMBER_VENUES = {
    operationId: "changeMemberVenues",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/members/{memberId}/venues",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/members/{memberId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MEMBER = {
    operationId: "getMember",
    method: "GET",
    path: "/v1/organizations/{organizationId}/members/{memberId}",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/organizations/{organizationId}/members/{memberId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REMOVE_MEMBER = {
    operationId: "removeMember",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/members/{memberId}",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/invitations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_INVITATIONS = {
    operationId: "listInvitations",
    method: "GET",
    path: "/v1/organizations/{organizationId}/invitations",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/invitations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_INVITATION = {
    operationId: "createInvitation",
    method: "POST",
    path: "/v1/organizations/{organizationId}/invitations",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `DELETE /v1/organizations/{organizationId}/invitations/{invitationId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REVOKE_INVITATION = {
    operationId: "revokeInvitation",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/invitations/{invitationId}",
    queryParams: [],
    pathParams: ["organizationId", "invitationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/invitations/accept` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ACCEPT_INVITATION = {
    operationId: "acceptInvitation",
    method: "POST",
    path: "/v1/invitations/accept",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/invitations/preview` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PREVIEW_INVITATION = {
    operationId: "previewInvitation",
    method: "POST",
    path: "/v1/invitations/preview",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/ban` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const BAN_PLAYER_AT_VENUE = {
    operationId: "banPlayerAtVenue",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/ban",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/unban` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNBAN_PLAYER_AT_VENUE = {
    operationId: "unbanPlayerAtVenue",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/unban",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/players/{playerId}/ban` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const BAN_PLAYER = {
    operationId: "banPlayer",
    method: "POST",
    path: "/v1/organizations/{organizationId}/players/{playerId}/ban",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/players/{playerId}/unban` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNBAN_PLAYER = {
    operationId: "unbanPlayer",
    method: "POST",
    path: "/v1/organizations/{organizationId}/players/{playerId}/unban",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/bans` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYER_BANS = {
    operationId: "listPlayerBans",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/bans",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/players/{playerId}/ban` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const BAN_PLAYER_ON_PLATFORM = {
    operationId: "banPlayerOnPlatform",
    method: "POST",
    path: "/v1/hq/players/{playerId}/ban",
    queryParams: [],
    pathParams: ["playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/players/{playerId}/unban` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNBAN_PLAYER_ON_PLATFORM = {
    operationId: "unbanPlayerOnPlatform",
    method: "POST",
    path: "/v1/hq/players/{playerId}/unban",
    queryParams: [],
    pathParams: ["playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/players` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_PLAYERS = {
    operationId: "listHqPlayers",
    method: "GET",
    path: "/v1/hq/players",
    queryParams: ["cursor", "limit", "q"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/players/{playerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_PLAYER = {
    operationId: "getHqPlayer",
    method: "GET",
    path: "/v1/hq/players/{playerId}",
    queryParams: [],
    pathParams: ["playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/providers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_PROVIDERS = {
    operationId: "listHqProviders",
    method: "GET",
    path: "/v1/hq/providers",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/providers/{providerId}/test` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const TEST_HQ_PROVIDER = {
    operationId: "testHqProvider",
    method: "POST",
    path: "/v1/hq/providers/{providerId}/test",
    queryParams: [],
    pathParams: ["providerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/members/{memberId}/status` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CHANGE_MEMBER_STATUS = {
    operationId: "changeMemberStatus",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/members/{memberId}/status",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/roles/{role}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ROLE = {
    operationId: "getRole",
    method: "GET",
    path: "/v1/organizations/{organizationId}/roles/{role}",
    queryParams: [],
    pathParams: ["organizationId", "role"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/roles/{role}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_ROLE = {
    operationId: "updateRole",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/roles/{role}",
    queryParams: [],
    pathParams: ["organizationId", "role"],
    headerParams: [],
    hasBody: true,
};
/**
 * `DELETE /v1/organizations/{organizationId}/roles/{role}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const DELETE_ROLE = {
    operationId: "deleteRole",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/roles/{role}",
    queryParams: [],
    pathParams: ["organizationId", "role"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/roles/{role}/limits` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CHANGE_ROLE_LIMITS = {
    operationId: "changeRoleLimits",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/roles/{role}/limits",
    queryParams: [],
    pathParams: ["organizationId", "role"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/members/{memberId}/limits` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MEMBER_LIMITS = {
    operationId: "getMemberLimits",
    method: "GET",
    path: "/v1/organizations/{organizationId}/members/{memberId}/limits",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/members/{memberId}/limits` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CHANGE_MEMBER_LIMITS = {
    operationId: "changeMemberLimits",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/members/{memberId}/limits",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/id-checks` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_ID_CHECKS = {
    operationId: "listIdChecks",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/id-checks",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/players/{playerId}/id-checks` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RECORD_ID_CHECK = {
    operationId: "recordIdCheck",
    method: "POST",
    path: "/v1/organizations/{organizationId}/players/{playerId}/id-checks",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/id-checks/{idCheckId}/photo` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ID_CHECK_PHOTO = {
    operationId: "getIdCheckPhoto",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/id-checks/{idCheckId}/photo",
    queryParams: [],
    pathParams: ["organizationId", "playerId", "idCheckId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/files/{fileId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const READ_SIGNED_FILE = {
    operationId: "readSignedFile",
    method: "GET",
    path: "/v1/files/{fileId}",
    queryParams: ["organizationId", "expires", "signature"],
    pathParams: ["fileId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/roles` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_ROLES = {
    operationId: "listRoles",
    method: "GET",
    path: "/v1/organizations/{organizationId}/roles",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/roles` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_ROLE = {
    operationId: "createRole",
    method: "POST",
    path: "/v1/organizations/{organizationId}/roles",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/me/access` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_ACCESS = {
    operationId: "getMyAccess",
    method: "GET",
    path: "/v1/me/access",
    queryParams: ["organizationId", "venueId"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/organizations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_ORGANIZATIONS = {
    operationId: "listMyOrganizations",
    method: "GET",
    path: "/v1/me/organizations",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/venues` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_VENUES = {
    operationId: "listMyVenues",
    method: "GET",
    path: "/v1/me/venues",
    queryParams: ["organizationId"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/members/me/pins` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_STAFF_PINS = {
    operationId: "listMyStaffPins",
    method: "GET",
    path: "/v1/organizations/{organizationId}/members/me/pins",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/members/me/pin` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_MY_STAFF_PIN = {
    operationId: "setMyStaffPin",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/members/me/pin",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: ["x-clavian-venue"],
    hasBody: true,
};
/**
 * `DELETE /v1/organizations/{organizationId}/members/{memberId}/pin` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESET_STAFF_PIN = {
    operationId: "resetStaffPin",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/members/{memberId}/pin",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: ["x-clavian-venue"],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/members/shared-device` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SHARED_DEVICE = {
    operationId: "getSharedDevice",
    method: "GET",
    path: "/v1/organizations/{organizationId}/members/shared-device",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: ["x-clavian-venue"],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/members/shared-device` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const OPEN_SHARED_DEVICE = {
    operationId: "openSharedDevice",
    method: "POST",
    path: "/v1/organizations/{organizationId}/members/shared-device",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: ["x-clavian-venue"],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/members/{memberId}/unlock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNLOCK_SHARED_DEVICE = {
    operationId: "unlockSharedDevice",
    method: "POST",
    path: "/v1/organizations/{organizationId}/members/{memberId}/unlock",
    queryParams: [],
    pathParams: ["organizationId", "memberId"],
    headerParams: ["x-clavian-venue"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/members/shared-device/lock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOCK_SHARED_DEVICE = {
    operationId: "lockSharedDevice",
    method: "POST",
    path: "/v1/organizations/{organizationId}/members/shared-device/lock",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: ["x-clavian-venue"],
    hasBody: false,
};
/**
 * `POST /v1/me/contact-verification` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CONFIRM_CONTACT_CHANGE = {
    operationId: "confirmContactChange",
    method: "POST",
    path: "/v1/me/contact-verification",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/me/sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_SESSIONS = {
    operationId: "listMySessions",
    method: "GET",
    path: "/v1/me/sessions",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/me/sessions/{sessionId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REVOKE_MY_SESSION = {
    operationId: "revokeMySession",
    method: "DELETE",
    path: "/v1/me/sessions/{sessionId}",
    queryParams: [],
    pathParams: ["sessionId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/meta` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_META = {
    operationId: "getMeta",
    method: "GET",
    path: "/v1/meta",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/brand` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_BRAND = {
    operationId: "getHqBrand",
    method: "GET",
    path: "/v1/hq/brand",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/brand` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_HQ_BRAND = {
    operationId: "putHqBrand",
    method: "PUT",
    path: "/v1/hq/brand",
    queryParams: [],
    pathParams: [],
    headerParams: ["if-match"],
    hasBody: true,
};
/**
 * `POST /v1/realtime/token` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_REALTIME_TOKEN = {
    operationId: "createRealtimeToken",
    method: "POST",
    path: "/v1/realtime/token",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/device-auth/challenge` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_DEVICE_AUTH_CHALLENGE = {
    operationId: "createDeviceAuthChallenge",
    method: "POST",
    path: "/v1/device-auth/challenge",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/device-auth/token` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_DEVICE_AUTH_TOKEN = {
    operationId: "createDeviceAuthToken",
    method: "POST",
    path: "/v1/device-auth/token",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/context` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_CONTEXT = {
    operationId: "getStationContext",
    method: "GET",
    path: "/v1/station/context",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/snapshot` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_KIOSK_SNAPSHOT = {
    operationId: "getStationKioskSnapshot",
    method: "GET",
    path: "/v1/station/snapshot",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/kiosk-token` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STATION_KIOSK_TOKEN = {
    operationId: "createStationKioskToken",
    method: "POST",
    path: "/v1/station/kiosk-token",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/policy-bundle` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_POLICY_BUNDLE = {
    operationId: "getStationPolicyBundle",
    method: "GET",
    path: "/v1/station/policy-bundle",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/library` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_LIBRARY = {
    operationId: "getStationLibrary",
    method: "GET",
    path: "/v1/station/library",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/jwks` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_JWKS = {
    operationId: "getStationJwks",
    method: "GET",
    path: "/v1/station/jwks",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/messages/{commandId}/read` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const READ_STATION_MESSAGE = {
    operationId: "readStationMessage",
    method: "POST",
    path: "/v1/station/messages/{commandId}/read",
    queryParams: [],
    pathParams: ["commandId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/two-factor/enable` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ENABLE_TWO_FACTOR = {
    operationId: "enableTwoFactor",
    method: "POST",
    path: "/v1/auth/two-factor/enable",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/two-factor/verify-totp` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const VERIFY_TWO_FACTOR_TOTP = {
    operationId: "verifyTwoFactorTotp",
    method: "POST",
    path: "/v1/auth/two-factor/verify-totp",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/two-factor/verify-backup-code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const VERIFY_TWO_FACTOR_BACKUP_CODE = {
    operationId: "verifyTwoFactorBackupCode",
    method: "POST",
    path: "/v1/auth/two-factor/verify-backup-code",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/two-factor/generate-backup-codes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GENERATE_TWO_FACTOR_BACKUP_CODES = {
    operationId: "generateTwoFactorBackupCodes",
    method: "POST",
    path: "/v1/auth/two-factor/generate-backup-codes",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/two-factor/disable` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const DISABLE_TWO_FACTOR = {
    operationId: "disableTwoFactor",
    method: "POST",
    path: "/v1/auth/two-factor/disable",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/phone-number/send-otp` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SEND_PHONE_NUMBER_OTP = {
    operationId: "sendPhoneNumberOTP",
    method: "POST",
    path: "/v1/auth/phone-number/send-otp",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/phone-number/verify` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const VERIFY_PHONE_NUMBER = {
    operationId: "verifyPhoneNumber",
    method: "POST",
    path: "/v1/auth/phone-number/verify",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/phone-number/request-password-reset` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REQUEST_PASSWORD_RESET_PHONE_NUMBER = {
    operationId: "requestPasswordResetPhoneNumber",
    method: "POST",
    path: "/v1/auth/phone-number/request-password-reset",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/phone-number/reset-password` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESET_PASSWORD_PHONE_NUMBER = {
    operationId: "resetPasswordPhoneNumber",
    method: "POST",
    path: "/v1/auth/phone-number/reset-password",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/sign-up/email` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_UP_WITH_EMAIL_AND_PASSWORD = {
    operationId: "signUpWithEmailAndPassword",
    method: "POST",
    path: "/v1/auth/sign-up/email",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/email-otp/send-verification-otp` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SEND_EMAIL_VERIFICATION_OTP = {
    operationId: "sendEmailVerificationOTP",
    method: "POST",
    path: "/v1/auth/email-otp/send-verification-otp",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/email-otp/verify-email` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const VERIFY_EMAIL_OTP = {
    operationId: "verifyEmailOTP",
    method: "POST",
    path: "/v1/auth/email-otp/verify-email",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/sign-in/email` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_IN_EMAIL = {
    operationId: "signInEmail",
    method: "POST",
    path: "/v1/auth/sign-in/email",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/sign-in/username` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_IN_USERNAME = {
    operationId: "signInUsername",
    method: "POST",
    path: "/v1/auth/sign-in/username",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/sign-in/email-otp` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_IN_WITH_EMAIL_OTP = {
    operationId: "signInWithEmailOTP",
    method: "POST",
    path: "/v1/auth/sign-in/email-otp",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/email-otp/request-password-reset` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REQUEST_PASSWORD_RESET_WITH_EMAIL_OTP = {
    operationId: "requestPasswordResetWithEmailOTP",
    method: "POST",
    path: "/v1/auth/email-otp/request-password-reset",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/email-otp/reset-password` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESET_PASSWORD_WITH_EMAIL_OTP = {
    operationId: "resetPasswordWithEmailOTP",
    method: "POST",
    path: "/v1/auth/email-otp/reset-password",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/is-username-available` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const IS_USERNAME_AVAILABLE = {
    operationId: "isUsernameAvailable",
    method: "POST",
    path: "/v1/auth/is-username-available",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/update-user` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_USER = {
    operationId: "updateUser",
    method: "POST",
    path: "/v1/auth/update-user",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/sign-in/social` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SOCIAL_SIGN_IN = {
    operationId: "socialSignIn",
    method: "POST",
    path: "/v1/auth/sign-in/social",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/auth/callback/{id}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CALLBACK_OAUTH = {
    operationId: "callbackOAuth",
    method: "GET",
    path: "/v1/auth/callback/{id}",
    queryParams: ["code", "state", "error", "error_description"],
    pathParams: ["id"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/auth/steam/start` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const STEAM_START = {
    operationId: "steamStart",
    method: "POST",
    path: "/v1/auth/steam/start",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/auth/steam/callback` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const STEAM_CALLBACK = {
    operationId: "steamCallback",
    method: "GET",
    path: "/v1/auth/steam/callback",
    queryParams: ["state"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/auth/link-social` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LINK_SOCIAL_ACCOUNT = {
    operationId: "linkSocialAccount",
    method: "POST",
    path: "/v1/auth/link-social",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/auth/station-link/start` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const STATION_LINK_START = {
    operationId: "stationLinkStart",
    method: "POST",
    path: "/v1/auth/station-link/start",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/auth/list-accounts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_USER_ACCOUNTS = {
    operationId: "listUserAccounts",
    method: "GET",
    path: "/v1/auth/list-accounts",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/auth/unlink-account` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNLINK_ACCOUNT = {
    operationId: "unlinkAccount",
    method: "POST",
    path: "/v1/auth/unlink-account",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/auth/get-session` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SESSION = {
    operationId: "getSession",
    method: "GET",
    path: "/v1/auth/get-session",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/auth/sign-out` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_OUT = {
    operationId: "signOut",
    method: "POST",
    path: "/v1/auth/sign-out",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/players` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYERS = {
    operationId: "listPlayers",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players",
    queryParams: ["cursor", "limit", "q", "memberQr", "tag"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PLAYER = {
    operationId: "getPlayer",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/players/{playerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_PLAYER = {
    operationId: "updatePlayer",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/players/{playerId}",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYER_SESSIONS = {
    operationId: "listPlayerSessions",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/sessions",
    queryParams: ["cursor", "limit", "venueId"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/orders` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYER_ORDERS = {
    operationId: "listPlayerOrders",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/orders",
    queryParams: ["cursor", "limit", "venueId"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/passes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYER_PASSES = {
    operationId: "listPlayerPasses",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/passes",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/wallet` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYER_WALLET = {
    operationId: "listPlayerWallet",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/wallet",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/points` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYER_POINTS = {
    operationId: "listPlayerPoints",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/points",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/organizations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_ORGANIZATIONS = {
    operationId: "listHqOrganizations",
    method: "GET",
    path: "/v1/hq/organizations",
    queryParams: ["cursor", "limit", "owner"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_HQ_ORGANIZATION = {
    operationId: "createHqOrganization",
    method: "POST",
    path: "/v1/hq/organizations",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/organizations/pending` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REGISTER_PENDING_ORGANIZATION = {
    operationId: "registerPendingOrganization",
    method: "POST",
    path: "/v1/hq/organizations/pending",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/organizations/{organizationId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_ORGANIZATION = {
    operationId: "getHqOrganization",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/approval` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const DECIDE_HQ_ORGANIZATION = {
    operationId: "decideHqOrganization",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/approval",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/owner-invitations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_HQ_OWNER_INVITATION = {
    operationId: "createHqOwnerInvitation",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/owner-invitations",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/owner` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_ORGANIZATION_OWNER = {
    operationId: "getHqOrganizationOwner",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/owner",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/owner-invitations/{invitationId}/resend` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESEND_HQ_OWNER_INVITATION = {
    operationId: "resendHqOwnerInvitation",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/owner-invitations/{invitationId}/resend",
    queryParams: [],
    pathParams: ["organizationId", "invitationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/hq/organizations/{organizationId}/owner-invitations/{invitationId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const WITHDRAW_HQ_OWNER_INVITATION = {
    operationId: "withdrawHqOwnerInvitation",
    method: "DELETE",
    path: "/v1/hq/organizations/{organizationId}/owner-invitations/{invitationId}",
    queryParams: [],
    pathParams: ["organizationId", "invitationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/owner-invitations/{invitationId}/link` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_OWNER_INVITATION_LINK = {
    operationId: "getHqOwnerInvitationLink",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/owner-invitations/{invitationId}/link",
    queryParams: [],
    pathParams: ["organizationId", "invitationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/catalogue/search` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SEARCH_CATALOGUE = {
    operationId: "searchCatalogue",
    method: "GET",
    path: "/v1/hq/catalogue/search",
    queryParams: ["q"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/catalogue/games` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_CATALOGUE_GAMES = {
    operationId: "listCatalogueGames",
    method: "GET",
    path: "/v1/hq/catalogue/games",
    queryParams: ["cursor", "limit", "kind"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/games` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MIRROR_CATALOGUE_GAME = {
    operationId: "mirrorCatalogueGame",
    method: "POST",
    path: "/v1/hq/catalogue/games",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/catalogue/games/{id}/refresh` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REFRESH_CATALOGUE_GAME = {
    operationId: "refreshCatalogueGame",
    method: "POST",
    path: "/v1/hq/catalogue/games/{id}/refresh",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/catalogue/games/{id}/launch-recipes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_CATALOGUE_GAME_LAUNCH_RECIPES = {
    operationId: "setCatalogueGameLaunchRecipes",
    method: "PUT",
    path: "/v1/hq/catalogue/games/{id}/launch-recipes",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/catalogue/games/{id}/trailers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_GAME_TRAILERS = {
    operationId: "listGameTrailers",
    method: "GET",
    path: "/v1/hq/catalogue/games/{id}/trailers",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/games/{id}/trailers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_GAME_TRAILER = {
    operationId: "createGameTrailer",
    method: "POST",
    path: "/v1/hq/catalogue/games/{id}/trailers",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/catalogue/games/{id}/trailers/{trailerId}/complete` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMPLETE_GAME_TRAILER = {
    operationId: "completeGameTrailer",
    method: "POST",
    path: "/v1/hq/catalogue/games/{id}/trailers/{trailerId}/complete",
    queryParams: [],
    pathParams: ["id", "trailerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/hq/catalogue/games/{id}/trailers/{trailerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const DELETE_GAME_TRAILER = {
    operationId: "deleteGameTrailer",
    method: "DELETE",
    path: "/v1/hq/catalogue/games/{id}/trailers/{trailerId}",
    queryParams: [],
    pathParams: ["id", "trailerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/hq/catalogue/games/{id}/trailers/{trailerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_GAME_TRAILER = {
    operationId: "updateGameTrailer",
    method: "PATCH",
    path: "/v1/hq/catalogue/games/{id}/trailers/{trailerId}",
    queryParams: [],
    pathParams: ["id", "trailerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/catalogue/games/{id}/art-candidates` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_GAME_ART_CANDIDATES = {
    operationId: "listGameArtCandidates",
    method: "GET",
    path: "/v1/hq/catalogue/games/{id}/art-candidates",
    queryParams: ["kind"],
    pathParams: ["id"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/catalogue/games/{id}/art/{kind}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_GAME_ART = {
    operationId: "setGameArt",
    method: "PUT",
    path: "/v1/hq/catalogue/games/{id}/art/{kind}",
    queryParams: [],
    pathParams: ["id", "kind"],
    headerParams: [],
    hasBody: true,
};
/**
 * `DELETE /v1/hq/catalogue/games/{id}/art/{kind}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLEAR_GAME_ART = {
    operationId: "clearGameArt",
    method: "DELETE",
    path: "/v1/hq/catalogue/games/{id}/art/{kind}",
    queryParams: [],
    pathParams: ["id", "kind"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/apps` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_CATALOGUE_APP = {
    operationId: "createCatalogueApp",
    method: "POST",
    path: "/v1/hq/catalogue/apps",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/hq/catalogue/apps/{id}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_CATALOGUE_APP = {
    operationId: "updateCatalogueApp",
    method: "PATCH",
    path: "/v1/hq/catalogue/apps/{id}",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/catalogue/apps/common` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SEED_COMMON_CATALOGUE_APPS = {
    operationId: "seedCommonCatalogueApps",
    method: "POST",
    path: "/v1/hq/catalogue/apps/common",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/apps/{id}/icon` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_APP_ICON_UPLOAD = {
    operationId: "createAppIconUpload",
    method: "POST",
    path: "/v1/hq/catalogue/apps/{id}/icon",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/catalogue/apps/{id}/icon/{uploadId}/complete` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMPLETE_APP_ICON_UPLOAD = {
    operationId: "completeAppIconUpload",
    method: "POST",
    path: "/v1/hq/catalogue/apps/{id}/icon/{uploadId}/complete",
    queryParams: [],
    pathParams: ["id", "uploadId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/catalogue/games/{id}/detection` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_CATALOGUE_TITLE_DETECTION = {
    operationId: "setCatalogueTitleDetection",
    method: "PUT",
    path: "/v1/hq/catalogue/games/{id}/detection",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/catalogue/games/manual` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_CATALOGUE_GAME = {
    operationId: "createCatalogueGame",
    method: "POST",
    path: "/v1/hq/catalogue/games/manual",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/hq/catalogue/games/{id}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_CATALOGUE_GAME = {
    operationId: "updateCatalogueGame",
    method: "PATCH",
    path: "/v1/hq/catalogue/games/{id}",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/catalogue/games/{id}/usage` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_CATALOGUE_GAME_USAGE = {
    operationId: "getCatalogueGameUsage",
    method: "GET",
    path: "/v1/hq/catalogue/games/{id}/usage",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/games/{id}/archive` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ARCHIVE_CATALOGUE_GAME = {
    operationId: "archiveCatalogueGame",
    method: "POST",
    path: "/v1/hq/catalogue/games/{id}/archive",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/games/{id}/unarchive` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNARCHIVE_CATALOGUE_GAME = {
    operationId: "unarchiveCatalogueGame",
    method: "POST",
    path: "/v1/hq/catalogue/games/{id}/unarchive",
    queryParams: [],
    pathParams: ["id"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/detection/test` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const TEST_CATALOGUE_DETECTION = {
    operationId: "testCatalogueDetection",
    method: "POST",
    path: "/v1/hq/catalogue/detection/test",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const START_SESSION = {
    operationId: "startSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sessions",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/session` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_SESSION = {
    operationId: "getStationSession",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/session",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/sessions/{sessionId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SESSION_STATUS = {
    operationId: "getSessionStatus",
    method: "GET",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/sessions/{sessionId}/timeline` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SESSION_TIMELINE = {
    operationId: "getSessionTimeline",
    method: "GET",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/timeline",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/sessions/{sessionId}/ledger` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_SESSION_LEDGER = {
    operationId: "listSessionLedger",
    method: "GET",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/ledger",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/comp` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMP_SESSION = {
    operationId: "compSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/comp",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/sell-time` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SELL_SESSION_TIME = {
    operationId: "sellSessionTime",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/sell-time",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/message` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MESSAGE_SESSION = {
    operationId: "messageSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/message",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/move` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MOVE_SESSION = {
    operationId: "moveSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/move",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/end` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const END_SESSION = {
    operationId: "endSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/end",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/lock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOCK_SESSION = {
    operationId: "lockSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/lock",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sessions/quote` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const QUOTE_CONSOLE_SESSION = {
    operationId: "quoteConsoleSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sessions/quote",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/quote` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const QUOTE_SESSION_CHANGE = {
    operationId: "quoteSessionChange",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/quote",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/add-time` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ADD_SESSION_TIME = {
    operationId: "addSessionTime",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/add-time",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/sessions/{sessionId}/controllers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_SESSION_CONTROLLERS = {
    operationId: "setSessionControllers",
    method: "POST",
    path: "/v1/organizations/{organizationId}/sessions/{sessionId}/controllers",
    queryParams: [],
    pathParams: ["organizationId", "sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const START_STATION_SESSION = {
    operationId: "startStationSession",
    method: "POST",
    path: "/v1/station/sessions",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sessions/current/end` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const END_STATION_SESSION = {
    operationId: "endStationSession",
    method: "POST",
    path: "/v1/station/sessions/current/end",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/sessions/current/add-time` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ADD_TIME_STATION_SESSION = {
    operationId: "addTimeStationSession",
    method: "POST",
    path: "/v1/station/sessions/current/add-time",
    queryParams: [],
    pathParams: [],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/station/sessions/current/use-wallet` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const USE_WALLET_STATION_SESSION = {
    operationId: "useWalletStationSession",
    method: "POST",
    path: "/v1/station/sessions/current/use-wallet",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/station/sessions/current/wallet-use` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_STATION_WALLET_USE = {
    operationId: "setStationWalletUse",
    method: "PUT",
    path: "/v1/station/sessions/current/wallet-use",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sessions/current/lock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOCK_STATION_SESSION = {
    operationId: "lockStationSession",
    method: "POST",
    path: "/v1/station/sessions/current/lock",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sessions/current/unlock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNLOCK_STATION_SESSION = {
    operationId: "unlockStationSession",
    method: "POST",
    path: "/v1/station/sessions/current/unlock",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sessions/{sessionId}/end-report` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REPORT_STATION_SESSION_END = {
    operationId: "reportStationSessionEnd",
    method: "POST",
    path: "/v1/station/sessions/{sessionId}/end-report",
    queryParams: [],
    pathParams: ["sessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/sessions/current/lease` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_SESSION_LEASE = {
    operationId: "getStationSessionLease",
    method: "GET",
    path: "/v1/station/sessions/current/lease",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/funding-options` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_FUNDING_OPTIONS = {
    operationId: "getStationFundingOptions",
    method: "GET",
    path: "/v1/station/funding-options",
    queryParams: ["playerId"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/calls` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RAISE_CALL = {
    operationId: "raiseCall",
    method: "POST",
    path: "/v1/station/calls",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/calls/current/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_CALL = {
    operationId: "cancelCall",
    method: "POST",
    path: "/v1/station/calls/current/cancel",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/calls` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_CALLS = {
    operationId: "listCalls",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/calls",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/calls/{callId}/acknowledge` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ACKNOWLEDGE_CALL = {
    operationId: "acknowledgeCall",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/calls/{callId}/acknowledge",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "callId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/calls/{callId}/resolve` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESOLVE_CALL = {
    operationId: "resolveCall",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/calls/{callId}/resolve",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "callId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/product-categories` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MENU_CATEGORIES = {
    operationId: "listMenuCategories",
    method: "GET",
    path: "/v1/organizations/{organizationId}/product-categories",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/product-categories` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_MENU_CATEGORY = {
    operationId: "createMenuCategory",
    method: "POST",
    path: "/v1/organizations/{organizationId}/product-categories",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/product-categories/{categoryId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_MENU_CATEGORY = {
    operationId: "updateMenuCategory",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/product-categories/{categoryId}",
    queryParams: [],
    pathParams: ["organizationId", "categoryId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/products` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MENU_PRODUCTS = {
    operationId: "listMenuProducts",
    method: "GET",
    path: "/v1/organizations/{organizationId}/products",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/products` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_MENU_PRODUCT = {
    operationId: "createMenuProduct",
    method: "POST",
    path: "/v1/organizations/{organizationId}/products",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/products/{productId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MENU_PRODUCT = {
    operationId: "getMenuProduct",
    method: "GET",
    path: "/v1/organizations/{organizationId}/products/{productId}",
    queryParams: [],
    pathParams: ["organizationId", "productId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/products/{productId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_MENU_PRODUCT = {
    operationId: "updateMenuProduct",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/products/{productId}",
    queryParams: [],
    pathParams: ["organizationId", "productId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/products/{productId}/availability` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_PRODUCT_AVAILABILITY = {
    operationId: "setProductAvailability",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/products/{productId}/availability",
    queryParams: [],
    pathParams: ["organizationId", "productId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/menu` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE_MENU = {
    operationId: "getVenueMenu",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/menu",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/menu` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_VENUE_MENU_OVERRIDES = {
    operationId: "putVenueMenuOverrides",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/menu",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/menu/products/{productId}/availability` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_VENUE_PRODUCT_AVAILABILITY = {
    operationId: "setVenueProductAvailability",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/menu/products/{productId}/availability",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "productId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/food-orders` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_FOOD_ORDERS = {
    operationId: "listFoodOrders",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/food-orders",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/food-orders` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PLACE_FOOD_ORDER = {
    operationId: "placeFoodOrder",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/food-orders",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/food-orders/{orderId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_FOOD_ORDER = {
    operationId: "getFoodOrder",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/food-orders/{orderId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "orderId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/food-orders/{orderId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_FOOD_ORDER = {
    operationId: "cancelFoodOrder",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/food-orders/{orderId}/cancel",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "orderId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/food-orders` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PLACE_STATION_FOOD_ORDER = {
    operationId: "placeStationFoodOrder",
    method: "POST",
    path: "/v1/station/food-orders",
    queryParams: [],
    pathParams: [],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/station/menu` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_MENU = {
    operationId: "getStationMenu",
    method: "GET",
    path: "/v1/station/menu",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/sales` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_SALES = {
    operationId: "listSales",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales",
    queryParams: ["awaiting"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_SALE = {
    operationId: "createSale",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/quote` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const QUOTE_SALE = {
    operationId: "quoteSale",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/quote",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SALE = {
    operationId: "getSale",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/payments` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const TAKE_SALE_PAYMENT = {
    operationId: "takeSalePayment",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/payments",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_SALE = {
    operationId: "cancelSale",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/cancel",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/discount-code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const APPLY_DISCOUNT_CODE = {
    operationId: "applyDiscountCode",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/discount-code",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/discount` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const APPLY_MANUAL_DISCOUNT = {
    operationId: "applyManualDiscount",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/discount",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/refunds` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REFUND_SALE = {
    operationId: "refundSale",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/refunds",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/refunds/{refundId}/approve` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const APPROVE_SALE_REFUND = {
    operationId: "approveSaleRefund",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/refunds/{refundId}/approve",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId", "refundId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/document` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SALE_DOCUMENT = {
    operationId: "getSaleDocument",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/document",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/document/send` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SEND_SALE_DOCUMENT = {
    operationId: "sendSaleDocument",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/document/send",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/invoice/gstin` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_SALE_BUYER = {
    operationId: "setSaleBuyer",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/invoice/gstin",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/document/print` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PRINT_SALE_DOCUMENT = {
    operationId: "printSaleDocument",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/document/print",
    queryParams: ["layout"],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/counter-upi` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_COUNTER_UPI = {
    operationId: "getCounterUpi",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/counter-upi",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/discount-codes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_DISCOUNT_CODES = {
    operationId: "listDiscountCodes",
    method: "GET",
    path: "/v1/organizations/{organizationId}/discount-codes",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/discount-codes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_DISCOUNT_CODE = {
    operationId: "createDiscountCode",
    method: "POST",
    path: "/v1/organizations/{organizationId}/discount-codes",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/discount-codes/{discountCodeId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_DISCOUNT_CODE = {
    operationId: "updateDiscountCode",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/discount-codes/{discountCodeId}",
    queryParams: [],
    pathParams: ["organizationId", "discountCodeId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/retail/lookup` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOOKUP_RETAIL_PRODUCT = {
    operationId: "lookupRetailProduct",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/retail/lookup",
    queryParams: ["barcode"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/promotions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PROMOTIONS = {
    operationId: "listPromotions",
    method: "GET",
    path: "/v1/organizations/{organizationId}/promotions",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/promotions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_PROMOTION = {
    operationId: "createPromotion",
    method: "POST",
    path: "/v1/organizations/{organizationId}/promotions",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/promotions/{promotionId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_PROMOTION = {
    operationId: "updatePromotion",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/promotions/{promotionId}",
    queryParams: [],
    pathParams: ["organizationId", "promotionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/coupon-batches` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_COUPON_BATCHES = {
    operationId: "listCouponBatches",
    method: "GET",
    path: "/v1/organizations/{organizationId}/coupon-batches",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/coupon-batches` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_COUPON_BATCH = {
    operationId: "createCouponBatch",
    method: "POST",
    path: "/v1/organizations/{organizationId}/coupon-batches",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/coupons/redeem` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REDEEM_COUPON = {
    operationId: "redeemCoupon",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/coupons/redeem",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/discount-codes/check` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CHECK_STATION_DISCOUNT_CODE = {
    operationId: "checkStationDiscountCode",
    method: "POST",
    path: "/v1/station/discount-codes/check",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/quote` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const QUOTE_STATION_SALE = {
    operationId: "quoteStationSale",
    method: "POST",
    path: "/v1/station/quote",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/coupons/redeem` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REDEEM_STATION_COUPON = {
    operationId: "redeemStationCoupon",
    method: "POST",
    path: "/v1/station/coupons/redeem",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/recovery-code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ISSUE_STATION_RECOVERY_CODE = {
    operationId: "issueStationRecoveryCode",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/recovery-code",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/lockdown-test` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_LOCKDOWN_TEST = {
    operationId: "getStationLockdownTest",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/lockdown-test",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/lockdown-test` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RUN_STATION_LOCKDOWN_TEST = {
    operationId: "runStationLockdownTest",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/lockdown-test",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/lockdown-test/results` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REPORT_STATION_LOCKDOWN_TEST = {
    operationId: "reportStationLockdownTest",
    method: "POST",
    path: "/v1/station/lockdown-test/results",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/maintenance/sign-in` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_IN_STATION_MAINTENANCE = {
    operationId: "signInStationMaintenance",
    method: "POST",
    path: "/v1/station/maintenance/sign-in",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/maintenance/events` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REPORT_STATION_MAINTENANCE_EVENT = {
    operationId: "reportStationMaintenanceEvent",
    method: "POST",
    path: "/v1/station/maintenance/events",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/offline-policy` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_OFFLINE_POLICY = {
    operationId: "getStationOfflinePolicy",
    method: "GET",
    path: "/v1/station/offline-policy",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/offline-sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REPORT_STATION_OFFLINE_SESSION = {
    operationId: "reportStationOfflineSession",
    method: "POST",
    path: "/v1/station/offline-sessions",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/offline-staff-codes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_OFFLINE_STAFF_CODES = {
    operationId: "listOfflineStaffCodes",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/offline-staff-codes",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/offline-staff-codes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ISSUE_OFFLINE_STAFF_CODES = {
    operationId: "issueOfflineStaffCodes",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/offline-staff-codes",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/offline-staff-codes/{codeId}/revoke` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REVOKE_OFFLINE_STAFF_CODE = {
    operationId: "revokeOfflineStaffCode",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/offline-staff-codes/{codeId}/revoke",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "codeId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/offline-sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_OFFLINE_SESSIONS = {
    operationId: "listOfflineSessions",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/offline-sessions",
    queryParams: ["status"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/offline-sessions/{offlineSessionId}/resolve` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESOLVE_OFFLINE_SESSION = {
    operationId: "resolveOfflineSession",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/offline-sessions/{offlineSessionId}/resolve",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "offlineSessionId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/credit` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PLAYER_CREDIT = {
    operationId: "getPlayerCredit",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/credit",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/credit` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_PLAYER_CREDIT = {
    operationId: "setPlayerCredit",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/credit",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/receivable/write-off` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const WRITE_OFF_RECEIVABLE = {
    operationId: "writeOffReceivable",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/receivable/write-off",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/receivable/settle` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SETTLE_RECEIVABLE = {
    operationId: "settleReceivable",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/players/{playerId}/receivable/settle",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "playerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/on-account` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const TAKE_SALE_ON_ACCOUNT = {
    operationId: "takeSaleOnAccount",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/on-account",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/tax-registration` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE_TAX_REGISTRATION = {
    operationId: "getVenueTaxRegistration",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/tax-registration",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/tax-registration` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SCHEDULE_VENUE_TAX_REGISTRATION = {
    operationId: "scheduleVenueTaxRegistration",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/tax-registration",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/tax-registration/{registrationId}/withdraw` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const WITHDRAW_VENUE_TAX_REGISTRATION = {
    operationId: "withdrawVenueTaxRegistration",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/tax-registration/{registrationId}/withdraw",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "registrationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/rate-card` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE_RATE_CARD = {
    operationId: "getVenueRateCard",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/rate-card",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/rate-card` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUBLISH_VENUE_RATE_CARD = {
    operationId: "publishVenueRateCard",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/rate-card",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/tax-categories` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_TAX_CATEGORIES = {
    operationId: "listTaxCategories",
    method: "GET",
    path: "/v1/organizations/{organizationId}/tax-categories",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/tax-categories` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_TAX_CATEGORY = {
    operationId: "createTaxCategory",
    method: "POST",
    path: "/v1/organizations/{organizationId}/tax-categories",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/tax-categories/{taxCategoryId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_TAX_CATEGORY = {
    operationId: "updateTaxCategory",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/tax-categories/{taxCategoryId}",
    queryParams: [],
    pathParams: ["organizationId", "taxCategoryId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/kitchen/tickets` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_KITCHEN_TICKETS = {
    operationId: "listKitchenTickets",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/kitchen/tickets",
    queryParams: ["area", "state"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/kitchen/tickets/{ticketId}/state` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ADVANCE_KITCHEN_TICKET = {
    operationId: "advanceKitchenTicket",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/kitchen/tickets/{ticketId}/state",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "ticketId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/kitchen/tickets/{ticketId}/print` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PRINT_KITCHEN_TICKET = {
    operationId: "printKitchenTicket",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/kitchen/tickets/{ticketId}/print",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "ticketId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/printers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PRINTERS = {
    operationId: "listPrinters",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/printers",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/printers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_PRINTER = {
    operationId: "createPrinter",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/printers",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `DELETE /v1/organizations/{organizationId}/venues/{venueId}/printers/{printerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ARCHIVE_PRINTER = {
    operationId: "archivePrinter",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/printers/{printerId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "printerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/printers/{printerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_PRINTER = {
    operationId: "updatePrinter",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/printers/{printerId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "printerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/printers/{printerId}/test` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const TEST_PRINTER = {
    operationId: "testPrinter",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/printers/{printerId}/test",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "printerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/print-jobs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PRINT_JOBS = {
    operationId: "listPrintJobs",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/print-jobs",
    queryParams: ["limit"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/receipt` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PRINT_SALE_RECEIPT = {
    operationId: "printSaleReceipt",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/receipt",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/cloud-print/star/{organizationId}/{venueId}/{printerId}/{key}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const STAR_CLOUD_PRNT_JOB = {
    operationId: "starCloudPrntJob",
    method: "GET",
    path: "/v1/cloud-print/star/{organizationId}/{venueId}/{printerId}/{key}",
    queryParams: ["token", "type", "mac"],
    pathParams: ["organizationId", "venueId", "printerId", "key"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/cloud-print/star/{organizationId}/{venueId}/{printerId}/{key}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const STAR_CLOUD_PRNT_POLL = {
    operationId: "starCloudPrntPoll",
    method: "POST",
    path: "/v1/cloud-print/star/{organizationId}/{venueId}/{printerId}/{key}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "printerId", "key"],
    headerParams: [],
    hasBody: true,
};
/**
 * `DELETE /v1/cloud-print/star/{organizationId}/{venueId}/{printerId}/{key}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const STAR_CLOUD_PRNT_CONFIRM = {
    operationId: "starCloudPrntConfirm",
    method: "DELETE",
    path: "/v1/cloud-print/star/{organizationId}/{venueId}/{printerId}/{key}",
    queryParams: ["token", "code", "mac"],
    pathParams: ["organizationId", "venueId", "printerId", "key"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/cloud-print/epson/{organizationId}/{venueId}/{printerId}/{key}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const EPSON_SERVER_DIRECT_PRINT = {
    operationId: "epsonServerDirectPrint",
    method: "POST",
    path: "/v1/cloud-print/epson/{organizationId}/{venueId}/{printerId}/{key}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "printerId", "key"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/players/{playerId}/wallet/top-ups` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const TOP_UP_WALLET = {
    operationId: "topUpWallet",
    method: "POST",
    path: "/v1/organizations/{organizationId}/players/{playerId}/wallet/top-ups",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/wallet/balance` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_WALLET_BALANCE = {
    operationId: "getWalletBalance",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/wallet/balance",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/players/{playerId}/wallet/adjustments` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ADJUST_WALLET = {
    operationId: "adjustWallet",
    method: "POST",
    path: "/v1/organizations/{organizationId}/players/{playerId}/wallet/adjustments",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/players/{playerId}/wallet/refunds` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REFUND_WALLET = {
    operationId: "refundWallet",
    method: "POST",
    path: "/v1/organizations/{organizationId}/players/{playerId}/wallet/refunds",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/station/sessions/current/wallet` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_SESSION_WALLET = {
    operationId: "getStationSessionWallet",
    method: "GET",
    path: "/v1/station/sessions/current/wallet",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/wallet/top-ups` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REQUEST_STATION_WALLET_TOP_UP = {
    operationId: "requestStationWalletTopUp",
    method: "POST",
    path: "/v1/station/wallet/top-ups",
    queryParams: [],
    pathParams: [],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/station/wallet/top-ups/{topUpId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_WALLET_TOP_UP = {
    operationId: "getStationWalletTopUp",
    method: "GET",
    path: "/v1/station/wallet/top-ups/{topUpId}",
    queryParams: [],
    pathParams: ["topUpId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/wallet/top-ups/{topUpId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_STATION_WALLET_TOP_UP = {
    operationId: "cancelStationWalletTopUp",
    method: "POST",
    path: "/v1/station/wallet/top-ups/{topUpId}/cancel",
    queryParams: [],
    pathParams: ["topUpId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/wallet/top-up-requests` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_WALLET_TOP_UP_REQUESTS = {
    operationId: "listWalletTopUpRequests",
    method: "GET",
    path: "/v1/organizations/{organizationId}/wallet/top-up-requests",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/wallet/top-up-requests/{requestId}/complete` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMPLETE_WALLET_TOP_UP_REQUEST = {
    operationId: "completeWalletTopUpRequest",
    method: "POST",
    path: "/v1/organizations/{organizationId}/wallet/top-up-requests/{requestId}/complete",
    queryParams: [],
    pathParams: ["organizationId", "requestId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/wallet/top-up-requests/{requestId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_WALLET_TOP_UP_REQUEST = {
    operationId: "cancelWalletTopUpRequest",
    method: "POST",
    path: "/v1/organizations/{organizationId}/wallet/top-up-requests/{requestId}/cancel",
    queryParams: [],
    pathParams: ["organizationId", "requestId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/sessions/current/account` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_ACCOUNT = {
    operationId: "getStationAccount",
    method: "GET",
    path: "/v1/station/sessions/current/account",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/sessions/current/passes/{holdingId}/pin` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PIN_STATION_SESSION_PASS = {
    operationId: "pinStationSessionPass",
    method: "POST",
    path: "/v1/station/sessions/current/passes/{holdingId}/pin",
    queryParams: [],
    pathParams: ["holdingId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/sales/{saleId}/outstanding` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_SALE_OUTSTANDING = {
    operationId: "getStationSaleOutstanding",
    method: "GET",
    path: "/v1/station/sales/{saleId}/outstanding",
    queryParams: [],
    pathParams: ["saleId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/sales/{saleId}/upi` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RETRY_STATION_SALE_UPI = {
    operationId: "retryStationSaleUpi",
    method: "POST",
    path: "/v1/station/sales/{saleId}/upi",
    queryParams: [],
    pathParams: ["saleId"],
    headerParams: ["idempotency-key"],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/payment-intents` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_SALE_PAYMENT_INTENT = {
    operationId: "createSalePaymentIntent",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/sales/{saleId}/payment-intents",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "saleId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/payment-intents/{paymentIntentId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PAYMENT_INTENT = {
    operationId: "getPaymentIntent",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/payment-intents/{paymentIntentId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "paymentIntentId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/payment-intents/{paymentIntentId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_PAYMENT_INTENT = {
    operationId: "cancelPaymentIntent",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/payment-intents/{paymentIntentId}/cancel",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "paymentIntentId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/payments/online` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ONLINE_PAYMENTS_STATUS = {
    operationId: "getOnlinePaymentsStatus",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/payments/online",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/players/{playerId}/wallet/online-top-ups` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const BEGIN_ONLINE_WALLET_TOP_UP = {
    operationId: "beginOnlineWalletTopUp",
    method: "POST",
    path: "/v1/organizations/{organizationId}/players/{playerId}/wallet/online-top-ups",
    queryParams: [],
    pathParams: ["organizationId", "playerId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/webhooks/payments/{provider}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RECEIVE_PAYMENTS_WEBHOOK = {
    operationId: "receivePaymentsWebhook",
    method: "POST",
    path: "/v1/webhooks/payments/{provider}",
    queryParams: [],
    pathParams: ["provider"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/payments/checkout/{provider}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PAYMENTS_CHECKOUT_PAGE = {
    operationId: "getPaymentsCheckoutPage",
    method: "GET",
    path: "/v1/payments/checkout/{provider}",
    queryParams: [],
    pathParams: ["provider"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/payments` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_ORGANIZATION_PAYMENTS = {
    operationId: "getHqOrganizationPayments",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/payments",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/organizations/{organizationId}/payments/payee` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SAVE_HQ_ORGANIZATION_PAYEE = {
    operationId: "saveHqOrganizationPayee",
    method: "PUT",
    path: "/v1/hq/organizations/{organizationId}/payments/payee",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/payments/payee/refresh` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REFRESH_HQ_ORGANIZATION_PAYEE = {
    operationId: "refreshHqOrganizationPayee",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/payments/payee/refresh",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/shifts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_SHIFTS = {
    operationId: "listShifts",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts",
    queryParams: ["status", "businessDay", "varianceAlerted"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/shifts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const OPEN_SHIFT = {
    operationId: "openShift",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/shifts/current` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_CURRENT_SHIFT = {
    operationId: "getCurrentShift",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts/current",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SHIFT = {
    operationId: "getShift",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "shiftId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/cash-timeline` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SHIFT_CASH_TIMELINE = {
    operationId: "getShiftCashTimeline",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/cash-timeline",
    queryParams: ["cursor", "limit", "tenders", "orderNumber"],
    pathParams: ["organizationId", "venueId", "shiftId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/movements` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RECORD_CASH_MOVEMENT = {
    operationId: "recordCashMovement",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/movements",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "shiftId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/close` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLOSE_SHIFT = {
    operationId: "closeShift",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/close",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "shiftId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/join` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const JOIN_SHIFT = {
    operationId: "joinShift",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/join",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "shiftId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/leave` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LEAVE_SHIFT = {
    operationId: "leaveShift",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/shifts/{shiftId}/leave",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "shiftId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/day-close` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_BUSINESS_DAY_CLOSE = {
    operationId: "getBusinessDayClose",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/day-close",
    queryParams: ["businessDay"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/day-close` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLOSE_BUSINESS_DAY = {
    operationId: "closeBusinessDay",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/day-close",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/business-day` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_BUSINESS_DAY_STATUS = {
    operationId: "getBusinessDayStatus",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/business-day",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/day-close/sign-off` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SIGN_OFF_BUSINESS_DAY = {
    operationId: "signOffBusinessDay",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/day-close/sign-off",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/drawer/open` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const OPEN_DRAWER = {
    operationId: "openDrawer",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/drawer/open",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/counters` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_COUNTERS = {
    operationId: "listCounters",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/counters",
    queryParams: ["includeArchived"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/counters` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_COUNTER = {
    operationId: "createCounter",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/counters",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/counters/{counterId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_COUNTER = {
    operationId: "updateCounter",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/counters/{counterId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "counterId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/passes/products` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PASS_PRODUCTS = {
    operationId: "listPassProducts",
    method: "GET",
    path: "/v1/organizations/{organizationId}/passes/products",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/passes/products` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_PASS_PRODUCT = {
    operationId: "createPassProduct",
    method: "POST",
    path: "/v1/organizations/{organizationId}/passes/products",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/passes/products/{productId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PASS_PRODUCT = {
    operationId: "getPassProduct",
    method: "GET",
    path: "/v1/organizations/{organizationId}/passes/products/{productId}",
    queryParams: [],
    pathParams: ["organizationId", "productId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/passes/products/{productId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_PASS_PRODUCT = {
    operationId: "updatePassProduct",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/passes/products/{productId}",
    queryParams: [],
    pathParams: ["organizationId", "productId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/passes/products/{productId}/sell` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SELL_PASS = {
    operationId: "sellPass",
    method: "POST",
    path: "/v1/organizations/{organizationId}/passes/products/{productId}/sell",
    queryParams: [],
    pathParams: ["organizationId", "productId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/passes/products/{productId}/grant` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GRANT_PASS = {
    operationId: "grantPass",
    method: "POST",
    path: "/v1/organizations/{organizationId}/passes/products/{productId}/grant",
    queryParams: [],
    pathParams: ["organizationId", "productId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/passes/holdings` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PASS_HOLDINGS = {
    operationId: "listPassHoldings",
    method: "GET",
    path: "/v1/organizations/{organizationId}/passes/holdings",
    queryParams: ["cursor", "limit", "productId", "playerId", "status"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/passes/holdings/{holdingId}/refund` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REFUND_PASS_HOLDING = {
    operationId: "refundPassHolding",
    method: "POST",
    path: "/v1/organizations/{organizationId}/passes/holdings/{holdingId}/refund",
    queryParams: [],
    pathParams: ["organizationId", "holdingId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/passes/holdings/{holdingId}/void` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const VOID_PASS_HOLDING = {
    operationId: "voidPassHolding",
    method: "POST",
    path: "/v1/organizations/{organizationId}/passes/holdings/{holdingId}/void",
    queryParams: [],
    pathParams: ["organizationId", "holdingId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/passes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_PASS_SHOP = {
    operationId: "getStationPassShop",
    method: "GET",
    path: "/v1/station/passes",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/passes/{productId}/purchase` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PURCHASE_STATION_PASS = {
    operationId: "purchaseStationPass",
    method: "POST",
    path: "/v1/station/passes/{productId}/purchase",
    queryParams: [],
    pathParams: ["productId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/station/passes/purchases/{purchaseId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_PASS_PURCHASE = {
    operationId: "getStationPassPurchase",
    method: "GET",
    path: "/v1/station/passes/purchases/{purchaseId}",
    queryParams: [],
    pathParams: ["purchaseId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/passes/purchases/{purchaseId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_STATION_PASS_PURCHASE = {
    operationId: "cancelStationPassPurchase",
    method: "POST",
    path: "/v1/station/passes/purchases/{purchaseId}/cancel",
    queryParams: [],
    pathParams: ["purchaseId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/guest-passes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_GUEST_PASSES = {
    operationId: "listGuestPasses",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/guest-passes",
    queryParams: ["saleId", "state"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/sign-in/ticket` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REDEEM_STATION_TICKET = {
    operationId: "redeemStationTicket",
    method: "POST",
    path: "/v1/station/sign-in/ticket",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/me/guest-passes/claim` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLAIM_GUEST_PASS = {
    operationId: "claimGuestPass",
    method: "POST",
    path: "/v1/me/guest-passes/claim",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/catalogue` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const BROWSE_VENUE_CATALOGUE = {
    operationId: "browseVenueCatalogue",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/catalogue",
    queryParams: ["cursor", "limit", "q", "kind"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/library` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_LIBRARY_ENTRIES = {
    operationId: "listLibraryEntries",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/library` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ADD_LIBRARY_ENTRY = {
    operationId: "addLibraryEntry",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `DELETE /v1/organizations/{organizationId}/venues/{venueId}/library/{entryId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REMOVE_LIBRARY_ENTRY = {
    operationId: "removeLibraryEntry",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library/{entryId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "entryId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/library/{entryId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_LIBRARY_ENTRY = {
    operationId: "updateLibraryEntry",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library/{entryId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "entryId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/custom-apps` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_CUSTOM_APPS = {
    operationId: "listCustomApps",
    method: "GET",
    path: "/v1/organizations/{organizationId}/custom-apps",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/custom-apps` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_CUSTOM_APP = {
    operationId: "createCustomApp",
    method: "POST",
    path: "/v1/organizations/{organizationId}/custom-apps",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/custom-apps/{customAppId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_CUSTOM_APP = {
    operationId: "updateCustomApp",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/custom-apps/{customAppId}",
    queryParams: [],
    pathParams: ["organizationId", "customAppId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/custom-apps/{customAppId}/archive` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ARCHIVE_CUSTOM_APP = {
    operationId: "archiveCustomApp",
    method: "POST",
    path: "/v1/organizations/{organizationId}/custom-apps/{customAppId}/archive",
    queryParams: [],
    pathParams: ["organizationId", "customAppId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/custom-apps/{customAppId}/icon` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_CUSTOM_APP_ICON_UPLOAD = {
    operationId: "createCustomAppIconUpload",
    method: "POST",
    path: "/v1/organizations/{organizationId}/custom-apps/{customAppId}/icon",
    queryParams: [],
    pathParams: ["organizationId", "customAppId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/custom-apps/{customAppId}/icon/{uploadId}/complete` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COMPLETE_CUSTOM_APP_ICON_UPLOAD = {
    operationId: "completeCustomAppIconUpload",
    method: "POST",
    path: "/v1/organizations/{organizationId}/custom-apps/{customAppId}/icon/{uploadId}/complete",
    queryParams: [],
    pathParams: ["organizationId", "customAppId", "uploadId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/custom-apps` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const BROWSE_VENUE_CUSTOM_APPS = {
    operationId: "browseVenueCustomApps",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/custom-apps",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/station/installed` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_STATION_INSTALLED = {
    operationId: "putStationInstalled",
    method: "PUT",
    path: "/v1/station/installed",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/library/availability` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_LIBRARY_AVAILABILITY = {
    operationId: "getStationLibraryAvailability",
    method: "GET",
    path: "/v1/station/library/availability",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/installed` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_INSTALLED_TITLES = {
    operationId: "getStationInstalledTitles",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/installed",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/library/installs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_LIBRARY_INSTALL_MATRIX = {
    operationId: "getLibraryInstallMatrix",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library/installs",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/library/detected` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_DETECTED_TITLES = {
    operationId: "listDetectedTitles",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library/detected",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/library/rescan` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESCAN_LIBRARY_INSTALLS = {
    operationId: "rescanLibraryInstalls",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library/rescan",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/apps/{entryId}/install` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const INSTALL_STATION_APP = {
    operationId: "installStationApp",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/apps/{entryId}/install",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId", "entryId"],
    headerParams: ["idempotency-key"],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/library/{entryId}/install` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const INSTALL_LIBRARY_ENTRY = {
    operationId: "installLibraryEntry",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library/{entryId}/install",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "entryId"],
    headerParams: ["idempotency-key"],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/library/requests` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_CATALOGUE_REQUEST = {
    operationId: "createCatalogueRequest",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/library/requests",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/catalogue/requests` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_CATALOGUE_REQUESTS = {
    operationId: "listCatalogueRequests",
    method: "GET",
    path: "/v1/hq/catalogue/requests",
    queryParams: ["status"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/catalogue/requests/{requestId}/resolve` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESOLVE_CATALOGUE_REQUEST = {
    operationId: "resolveCatalogueRequest",
    method: "POST",
    path: "/v1/hq/catalogue/requests/{requestId}/resolve",
    queryParams: [],
    pathParams: ["requestId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PUT /v1/station/wake-readiness` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_STATION_WAKE_READINESS = {
    operationId: "putStationWakeReadiness",
    method: "PUT",
    path: "/v1/station/wake-readiness",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/wake-readiness` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_WAKE_STATUS = {
    operationId: "getStationWakeStatus",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/wake-readiness",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/wake-list` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_WAKE_LIST = {
    operationId: "getStationWakeList",
    method: "GET",
    path: "/v1/station/wake-list",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/wake-sends` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const POST_STATION_WAKE_SEND = {
    operationId: "postStationWakeSend",
    method: "POST",
    path: "/v1/station/wake-sends",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/game-plays` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const POST_STATION_GAME_PLAYS = {
    operationId: "postStationGamePlays",
    method: "POST",
    path: "/v1/station/game-plays",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/sessions/current/games` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_SESSION_GAMES = {
    operationId: "getStationSessionGames",
    method: "GET",
    path: "/v1/station/sessions/current/games",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/players/{playerId}/games` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_PLAYER_GAMES = {
    operationId: "listPlayerGames",
    method: "GET",
    path: "/v1/organizations/{organizationId}/players/{playerId}/games",
    queryParams: ["venueId"],
    pathParams: ["organizationId", "playerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/reports/games-played` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_GAMES_PLAYED_REPORT = {
    operationId: "getGamesPlayedReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/reports/games-played",
    queryParams: ["from", "to"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/reports/overview` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE_REPORT_OVERVIEW = {
    operationId: "getVenueReportOverview",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/reports/overview",
    queryParams: ["from", "to"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/reports/overview` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ORGANIZATION_REPORT_OVERVIEW = {
    operationId: "getOrganizationReportOverview",
    method: "GET",
    path: "/v1/organizations/{organizationId}/reports/overview",
    queryParams: ["from", "to"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/reports/range` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_REPORT_RANGE = {
    operationId: "getReportRange",
    method: "GET",
    path: "/v1/organizations/{organizationId}/reports/range",
    queryParams: ["preset", "venueId"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/reports/revenue` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_REVENUE_REPORT = {
    operationId: "getRevenueReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/reports/revenue",
    queryParams: ["from", "to", "venueId"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/reports/sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_SESSIONS_REPORT = {
    operationId: "getSessionsReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/reports/sessions",
    queryParams: ["from", "to", "venueId"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/reports/products` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_PRODUCTS_REPORT = {
    operationId: "getProductsReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/reports/products",
    queryParams: ["from", "to", "venueId"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/reports/staff` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STAFF_REPORT = {
    operationId: "getStaffReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/reports/staff",
    queryParams: ["from", "to", "venueId"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/reports/daily-summary` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_DAILY_SUMMARY = {
    operationId: "getDailySummary",
    method: "GET",
    path: "/v1/organizations/{organizationId}/reports/daily-summary",
    queryParams: ["day", "venueId"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/reports/daily-summary/send` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SEND_DAILY_SUMMARY = {
    operationId: "sendDailySummary",
    method: "POST",
    path: "/v1/organizations/{organizationId}/reports/daily-summary/send",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/floor/live` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_FLOOR_LIVE = {
    operationId: "getFloorLive",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/floor/live",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/live` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_LIVE = {
    operationId: "getHqLive",
    method: "GET",
    path: "/v1/hq/live",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/health` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_HEALTH = {
    operationId: "getStationHealth",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/health",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/telemetry` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_TELEMETRY = {
    operationId: "getStationTelemetry",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/telemetry",
    queryParams: ["hours"],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/needs-attention` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_NEEDS_ATTENTION = {
    operationId: "getNeedsAttention",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/needs-attention",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/alerts/clear` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLEAR_STATION_ALERTS = {
    operationId: "clearStationAlerts",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/alerts/clear",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/station-releases` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STATION_RELEASES = {
    operationId: "listStationReleases",
    method: "GET",
    path: "/v1/hq/station-releases",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/station-releases` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REGISTER_STATION_RELEASE = {
    operationId: "registerStationRelease",
    method: "POST",
    path: "/v1/hq/station-releases",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/hq/station-releases/{version}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_STATION_RELEASE = {
    operationId: "updateStationRelease",
    method: "PATCH",
    path: "/v1/hq/station-releases/{version}",
    queryParams: [],
    pathParams: ["version"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/station-rollouts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STATION_ROLLOUTS = {
    operationId: "listStationRollouts",
    method: "GET",
    path: "/v1/hq/station-rollouts",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/station-rollouts/{channel}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_STATION_ROLLOUT = {
    operationId: "setStationRollout",
    method: "PUT",
    path: "/v1/hq/station-rollouts/{channel}",
    queryParams: [],
    pathParams: ["channel"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/station-fleet` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_FLEET = {
    operationId: "getStationFleet",
    method: "GET",
    path: "/v1/hq/station-fleet",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/station-clients` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_VENUE_STATION_CLIENTS = {
    operationId: "listVenueStationClients",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/station-clients",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/station-installers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE_STATION_INSTALLERS = {
    operationId: "getVenueStationInstallers",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/station-installers",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/client-update/install-now` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const INSTALL_STATION_CLIENT_UPDATE_NOW = {
    operationId: "installStationClientUpdateNow",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/stations/{stationId}/client-update/install-now",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/client-update` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_CLIENT_UPDATE = {
    operationId: "getStationClientUpdate",
    method: "GET",
    path: "/v1/station/client-update",
    queryParams: ["clientVersion"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/station/client-update-status` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_STATION_CLIENT_UPDATE_STATUS = {
    operationId: "putStationClientUpdateStatus",
    method: "PUT",
    path: "/v1/station/client-update-status",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/release-keys` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_RELEASE_KEYS = {
    operationId: "getStationReleaseKeys",
    method: "GET",
    path: "/v1/station/release-keys",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/status` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_STATUS = {
    operationId: "getStockStatus",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/status",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/alerts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_ALERTS = {
    operationId: "getStockAlerts",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/alerts",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/items` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STOCK_ITEMS = {
    operationId: "listStockItems",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/items",
    queryParams: ["kind", "level", "q", "includeArchived"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/items` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STOCK_ITEM = {
    operationId: "createStockItem",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/items",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/items/{stockItemId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_ITEM = {
    operationId: "getStockItem",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/items/{stockItemId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stockItemId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/inventory/items/{stockItemId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_STOCK_ITEM = {
    operationId: "updateStockItem",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/items/{stockItemId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "stockItemId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/lookup` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOOKUP_STOCK_BARCODE = {
    operationId: "lookupStockBarcode",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/lookup",
    queryParams: ["barcode"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/movements` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STOCK_MOVEMENTS = {
    operationId: "listStockMovements",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/movements",
    queryParams: ["cursor", "limit", "stockItemId", "kind", "from", "to", "fromDay", "toDay"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/suppliers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STOCK_SUPPLIERS = {
    operationId: "listStockSuppliers",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/suppliers",
    queryParams: ["includeArchived"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/suppliers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STOCK_SUPPLIER = {
    operationId: "createStockSupplier",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/suppliers",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/inventory/suppliers/{supplierId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_STOCK_SUPPLIER = {
    operationId: "updateStockSupplier",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/suppliers/{supplierId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "supplierId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/receipts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STOCK_RECEIPTS = {
    operationId: "listStockReceipts",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/receipts",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/receipts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STOCK_RECEIPT = {
    operationId: "createStockReceipt",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/receipts",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/receipts/{receiptId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_RECEIPT = {
    operationId: "getStockReceipt",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/receipts/{receiptId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "receiptId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/usage` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RECORD_STOCK_USAGE = {
    operationId: "recordStockUsage",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/usage",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/adjustments` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STOCK_ADJUSTMENT = {
    operationId: "createStockAdjustment",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/adjustments",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/counts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STOCK_COUNTS = {
    operationId: "listStockCounts",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/counts",
    queryParams: ["cursor", "limit", "status"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/counts` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_STOCK_COUNT = {
    operationId: "createStockCount",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/counts",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_COUNT = {
    operationId: "getStockCount",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "countId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}/lines` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_STOCK_COUNT_LINES = {
    operationId: "putStockCountLines",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}/lines",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "countId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}/submit` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SUBMIT_STOCK_COUNT = {
    operationId: "submitStockCount",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}/submit",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "countId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_STOCK_COUNT = {
    operationId: "cancelStockCount",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/counts/{countId}/cancel",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "countId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/recipes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_STOCK_RECIPES = {
    operationId: "listStockRecipes",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/recipes",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/products/{productId}/recipes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_PRODUCT_RECIPES = {
    operationId: "getStockProductRecipes",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/products/{productId}/recipes",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "productId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/inventory/products/{productId}/recipes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUT_STOCK_PRODUCT_RECIPES = {
    operationId: "putStockProductRecipes",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/products/{productId}/recipes",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "productId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/inventory/copy-from-venue` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const COPY_STOCK_FROM_VENUE = {
    operationId: "copyStockFromVenue",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/copy-from-venue",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/valuation` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_VALUATION_REPORT = {
    operationId: "getStockValuationReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/valuation",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/usage` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_USAGE_REPORT = {
    operationId: "getStockUsageReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/usage",
    queryParams: ["from", "to"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/variance` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_VARIANCE_REPORT = {
    operationId: "getStockVarianceReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/variance",
    queryParams: ["from", "to"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/margins` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STOCK_MARGINS_REPORT = {
    operationId: "getStockMarginsReport",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/inventory/reports/margins",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/business-details` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ORGANIZATION_BUSINESS_DETAILS = {
    operationId: "getOrganizationBusinessDetails",
    method: "GET",
    path: "/v1/organizations/{organizationId}/business-details",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/business-details` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_ORGANIZATION_BUSINESS_DETAILS = {
    operationId: "updateOrganizationBusinessDetails",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/business-details",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/setup` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_ORGANIZATION_SETUP = {
    operationId: "getOrganizationSetup",
    method: "GET",
    path: "/v1/organizations/{organizationId}/setup",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/setup/skips/{step}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SKIP_ORGANIZATION_SETUP_STEP = {
    operationId: "skipOrganizationSetupStep",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/setup/skips/{step}",
    queryParams: [],
    pathParams: ["organizationId", "step"],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/organizations/{organizationId}/setup/skips/{step}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNSKIP_ORGANIZATION_SETUP_STEP = {
    operationId: "unskipOrganizationSetupStep",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/setup/skips/{step}",
    queryParams: [],
    pathParams: ["organizationId", "step"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/setup` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_VENUE_SETUP = {
    operationId: "getVenueSetup",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/setup",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/setup/skips/{step}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SKIP_VENUE_SETUP_STEP = {
    operationId: "skipVenueSetupStep",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/setup/skips/{step}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "step"],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/organizations/{organizationId}/venues/{venueId}/setup/skips/{step}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNSKIP_VENUE_SETUP_STEP = {
    operationId: "unskipVenueSetupStep",
    method: "DELETE",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/setup/skips/{step}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "step"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/setup` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_SETUP = {
    operationId: "listHqSetup",
    method: "GET",
    path: "/v1/hq/setup",
    queryParams: ["organizationId"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/leads` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_LEADS = {
    operationId: "listHqLeads",
    method: "GET",
    path: "/v1/hq/leads",
    queryParams: ["cursor", "limit", "stage", "city", "priority", "ownerId", "doNotContact", "q", "sort"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/leads` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_HQ_LEAD = {
    operationId: "createHqLead",
    method: "POST",
    path: "/v1/hq/leads",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/leads/import` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const IMPORT_HQ_LEADS = {
    operationId: "importHqLeads",
    method: "POST",
    path: "/v1/hq/leads/import",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/leads/cities` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_LEAD_CITIES = {
    operationId: "listHqLeadCities",
    method: "GET",
    path: "/v1/hq/leads/cities",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/leads/queue` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_LEAD_QUEUE = {
    operationId: "getHqLeadQueue",
    method: "GET",
    path: "/v1/hq/leads/queue",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/leads/funnel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_LEAD_FUNNEL = {
    operationId: "getHqLeadFunnel",
    method: "GET",
    path: "/v1/hq/leads/funnel",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/leads/assignees` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_LEAD_ASSIGNEES = {
    operationId: "listHqLeadAssignees",
    method: "GET",
    path: "/v1/hq/leads/assignees",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/leads/{leadId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_HQ_LEAD = {
    operationId: "getHqLead",
    method: "GET",
    path: "/v1/hq/leads/{leadId}",
    queryParams: [],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `DELETE /v1/hq/leads/{leadId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const DELETE_HQ_LEAD = {
    operationId: "deleteHqLead",
    method: "DELETE",
    path: "/v1/hq/leads/{leadId}",
    queryParams: [],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/hq/leads/{leadId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_HQ_LEAD = {
    operationId: "updateHqLead",
    method: "PATCH",
    path: "/v1/hq/leads/{leadId}",
    queryParams: [],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/leads/{leadId}/stage` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CHANGE_HQ_LEAD_STAGE = {
    operationId: "changeHqLeadStage",
    method: "POST",
    path: "/v1/hq/leads/{leadId}/stage",
    queryParams: [],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/leads/{leadId}/activities` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_LEAD_ACTIVITIES = {
    operationId: "listHqLeadActivities",
    method: "GET",
    path: "/v1/hq/leads/{leadId}/activities",
    queryParams: ["cursor", "limit"],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/leads/{leadId}/activities` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOG_HQ_LEAD_ACTIVITY = {
    operationId: "logHqLeadActivity",
    method: "POST",
    path: "/v1/hq/leads/{leadId}/activities",
    queryParams: [],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/leads/{leadId}/outreach` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const OPEN_HQ_LEAD_OUTREACH = {
    operationId: "openHqLeadOutreach",
    method: "POST",
    path: "/v1/hq/leads/{leadId}/outreach",
    queryParams: [],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/leads/{leadId}/convert` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CONVERT_HQ_LEAD = {
    operationId: "convertHqLead",
    method: "POST",
    path: "/v1/hq/leads/{leadId}/convert",
    queryParams: [],
    pathParams: ["leadId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/lead-templates` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_LEAD_TEMPLATES = {
    operationId: "listHqLeadTemplates",
    method: "GET",
    path: "/v1/hq/lead-templates",
    queryParams: ["includeArchived"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/lead-templates` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_HQ_LEAD_TEMPLATE = {
    operationId: "createHqLeadTemplate",
    method: "POST",
    path: "/v1/hq/lead-templates",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/hq/lead-templates/{templateId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_HQ_LEAD_TEMPLATE = {
    operationId: "updateHqLeadTemplate",
    method: "PATCH",
    path: "/v1/hq/lead-templates/{templateId}",
    queryParams: [],
    pathParams: ["templateId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/lead-templates/{templateId}/archive` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ARCHIVE_HQ_LEAD_TEMPLATE = {
    operationId: "archiveHqLeadTemplate",
    method: "POST",
    path: "/v1/hq/lead-templates/{templateId}/archive",
    queryParams: [],
    pathParams: ["templateId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/addons` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_ADDONS = {
    operationId: "listHqAddons",
    method: "GET",
    path: "/v1/hq/addons",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/addons` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_HQ_ADDON = {
    operationId: "createHqAddon",
    method: "POST",
    path: "/v1/hq/addons",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/hq/addons/{addonKey}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_HQ_ADDON = {
    operationId: "updateHqAddon",
    method: "PATCH",
    path: "/v1/hq/addons/{addonKey}",
    queryParams: [],
    pathParams: ["addonKey"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/addons` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_HQ_ORGANIZATION_ADDONS = {
    operationId: "listHqOrganizationAddons",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/addons",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/addons` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ATTACH_HQ_ORGANIZATION_ADDON = {
    operationId: "attachHqOrganizationAddon",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/addons",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/hq/organizations/{organizationId}/addons/{organizationAddonId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_HQ_ORGANIZATION_ADDON = {
    operationId: "updateHqOrganizationAddon",
    method: "PATCH",
    path: "/v1/hq/organizations/{organizationId}/addons/{organizationAddonId}",
    queryParams: [],
    pathParams: ["organizationId", "organizationAddonId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/addons` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_ORGANIZATION_ADDONS = {
    operationId: "listOrganizationAddons",
    method: "GET",
    path: "/v1/organizations/{organizationId}/addons",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/imported-players` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_IMPORTED_PLAYERS = {
    operationId: "listImportedPlayers",
    method: "GET",
    path: "/v1/organizations/{organizationId}/imported-players",
    queryParams: ["cursor", "limit", "q", "status", "venueId"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/migrations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MIGRATION_RUNS = {
    operationId: "listMigrationRuns",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/migrations",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/migrations` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_MIGRATION_RUN = {
    operationId: "createMigrationRun",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/migrations",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/migrations/{migrationId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MIGRATION_RUN = {
    operationId: "getMigrationRun",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/migrations/{migrationId}/file` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPLOAD_MIGRATION_FILE = {
    operationId: "uploadMigrationFile",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/file",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PUT /v1/hq/organizations/{organizationId}/migrations/{migrationId}/mapping` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_MIGRATION_MAPPING = {
    operationId: "updateMigrationMapping",
    method: "PUT",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/mapping",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/migrations/{migrationId}/rows` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MIGRATION_ROWS = {
    operationId: "listMigrationRows",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/rows",
    queryParams: ["cursor", "limit", "status", "issue"],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/hq/organizations/{organizationId}/migrations/{migrationId}/ticks` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_MIGRATION_TICKS = {
    operationId: "setMigrationTicks",
    method: "PUT",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/ticks",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/migrations/{migrationId}/import` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const IMPORT_MIGRATION = {
    operationId: "importMigration",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/import",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/migrations/{migrationId}/undo` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNDO_MIGRATION = {
    operationId: "undoMigration",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/undo",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/hq/organizations/{organizationId}/migrations/{migrationId}/report` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MIGRATION_REPORT = {
    operationId: "getMigrationReport",
    method: "GET",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/report",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/station/carried-over/options` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_CARRIED_OVER_OPTIONS = {
    operationId: "getStationCarriedOverOptions",
    method: "GET",
    path: "/v1/station/carried-over/options",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/sign-in/carried-over/code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REQUEST_STATION_CARRIED_OVER_CODE = {
    operationId: "requestStationCarriedOverCode",
    method: "POST",
    path: "/v1/station/sign-in/carried-over/code",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/station/sign-in/carried-over` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLAIM_STATION_CARRIED_OVER = {
    operationId: "claimStationCarriedOver",
    method: "POST",
    path: "/v1/station/sign-in/carried-over",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/station/carried-over/offer` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_STATION_CARRIED_OVER_OFFER = {
    operationId: "getStationCarriedOverOffer",
    method: "GET",
    path: "/v1/station/carried-over/offer",
    queryParams: ["playerId"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/station/carried-over/accept` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ACCEPT_STATION_CARRIED_OVER_OFFER = {
    operationId: "acceptStationCarriedOverOffer",
    method: "POST",
    path: "/v1/station/carried-over/accept",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/carried-over/link` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const READ_CARRIED_OVER_LINK = {
    operationId: "readCarriedOverLink",
    method: "POST",
    path: "/v1/carried-over/link",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/me/carried-over/claims` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLAIM_CARRIED_OVER_BY_LINK = {
    operationId: "claimCarriedOverByLink",
    method: "POST",
    path: "/v1/me/carried-over/claims",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/imported-players/{importedPlayerId}/claim/email-code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REQUEST_COUNTER_CLAIM_EMAIL_CODE = {
    operationId: "requestCounterClaimEmailCode",
    method: "POST",
    path: "/v1/organizations/{organizationId}/imported-players/{importedPlayerId}/claim/email-code",
    queryParams: [],
    pathParams: ["organizationId", "importedPlayerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/imported-players/{importedPlayerId}/claim/approvers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_COUNTER_CLAIM_APPROVERS = {
    operationId: "listCounterClaimApprovers",
    method: "GET",
    path: "/v1/organizations/{organizationId}/imported-players/{importedPlayerId}/claim/approvers",
    queryParams: [],
    pathParams: ["organizationId", "importedPlayerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/imported-players/{importedPlayerId}/claim` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CLAIM_AT_COUNTER = {
    operationId: "claimAtCounter",
    method: "POST",
    path: "/v1/organizations/{organizationId}/imported-players/{importedPlayerId}/claim",
    queryParams: [],
    pathParams: ["organizationId", "importedPlayerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/imported-players/write-offs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_CARRIED_OVER_WRITE_OFFS = {
    operationId: "listCarriedOverWriteOffs",
    method: "GET",
    path: "/v1/organizations/{organizationId}/imported-players/write-offs",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/imported-players/write-offs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const WRITE_OFF_CARRIED_OVER = {
    operationId: "writeOffCarriedOver",
    method: "POST",
    path: "/v1/organizations/{organizationId}/imported-players/write-offs",
    queryParams: [],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/hq/organizations/{organizationId}/migrations/{migrationId}/moved-email` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SEND_MOVED_EMAIL = {
    operationId: "sendMovedEmail",
    method: "POST",
    path: "/v1/hq/organizations/{organizationId}/migrations/{migrationId}/moved-email",
    queryParams: [],
    pathParams: ["organizationId", "migrationId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/me/wallets` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_WALLETS = {
    operationId: "listMyWallets",
    method: "GET",
    path: "/v1/me/wallets",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/wallets/{organizationId}/statement` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_WALLET_STATEMENT = {
    operationId: "getMyWalletStatement",
    method: "GET",
    path: "/v1/me/wallets/{organizationId}/statement",
    queryParams: ["cursor", "limit"],
    pathParams: ["organizationId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/passes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_PASSES = {
    operationId: "listMyPasses",
    method: "GET",
    path: "/v1/me/passes",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/play-sessions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_PLAY_SESSIONS = {
    operationId: "listMyPlaySessions",
    method: "GET",
    path: "/v1/me/play-sessions",
    queryParams: ["cursor", "limit"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/play-sessions/current` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_CURRENT_PLAY_SESSION = {
    operationId: "getMyCurrentPlaySession",
    method: "GET",
    path: "/v1/me/play-sessions/current",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/me/play-sessions/current/lock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LOCK_MY_PLAY_SESSION = {
    operationId: "lockMyPlaySession",
    method: "POST",
    path: "/v1/me/play-sessions/current/lock",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/me/play-sessions/current/unlock` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNLOCK_MY_PLAY_SESSION = {
    operationId: "unlockMyPlaySession",
    method: "POST",
    path: "/v1/me/play-sessions/current/unlock",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/me/play-sessions/current/end` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const END_MY_PLAY_SESSION = {
    operationId: "endMyPlaySession",
    method: "POST",
    path: "/v1/me/play-sessions/current/end",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/me/play-sessions/current/passes/{holdingId}/pin` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PIN_PASS_ON_MY_PLAY_SESSION = {
    operationId: "pinPassOnMyPlaySession",
    method: "POST",
    path: "/v1/me/play-sessions/current/passes/{holdingId}/pin",
    queryParams: [],
    pathParams: ["holdingId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/me/play-sessions/current/calls` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CALL_STAFF_FROM_MY_PLAY_SESSION = {
    operationId: "callStaffFromMyPlaySession",
    method: "POST",
    path: "/v1/me/play-sessions/current/calls",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/me/play-sessions/current/calls/cancel` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CANCEL_MY_STAFF_CALL = {
    operationId: "cancelMyStaffCall",
    method: "POST",
    path: "/v1/me/play-sessions/current/calls/cancel",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/orders` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_MY_ORDERS = {
    operationId: "listMyOrders",
    method: "GET",
    path: "/v1/me/orders",
    queryParams: ["cursor", "limit"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/orders/{saleId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_ORDER = {
    operationId: "getMyOrder",
    method: "GET",
    path: "/v1/me/orders/{saleId}",
    queryParams: [],
    pathParams: ["saleId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/me/venues/{venueId}/passes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_VENUE_PASS_SHOP = {
    operationId: "getMyVenuePassShop",
    method: "GET",
    path: "/v1/me/venues/{venueId}/passes",
    queryParams: [],
    pathParams: ["venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/me/venues/{venueId}/passes/{productId}/purchase` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PURCHASE_MY_PASS = {
    operationId: "purchaseMyPass",
    method: "POST",
    path: "/v1/me/venues/{venueId}/passes/{productId}/purchase",
    queryParams: [],
    pathParams: ["venueId", "productId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/me/venues/{venueId}/wallet/online-top-ups` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const BEGIN_MY_ONLINE_TOP_UP = {
    operationId: "beginMyOnlineTopUp",
    method: "POST",
    path: "/v1/me/venues/{venueId}/wallet/online-top-ups",
    queryParams: [],
    pathParams: ["venueId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `GET /v1/me/payments/{paymentIntentId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_MY_PAYMENT = {
    operationId: "getMyPayment",
    method: "GET",
    path: "/v1/me/payments/{paymentIntentId}",
    queryParams: [],
    pathParams: ["paymentIntentId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/servers` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_BOOT_SERVERS = {
    operationId: "listBootServers",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/servers",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/servers/pairing-code` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_BOOT_SERVER_PAIRING_CODE = {
    operationId: "createBootServerPairingCode",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/servers/pairing-code",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/boot/servers/{bootServerId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_BOOT_SERVER = {
    operationId: "updateBootServer",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/servers/{bootServerId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootServerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/servers/{bootServerId}/unpair` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UNPAIR_BOOT_SERVER = {
    operationId: "unpairBootServer",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/servers/{bootServerId}/unpair",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootServerId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/servers/{bootServerId}/update` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_BOOT_SERVER_SOFTWARE = {
    operationId: "updateBootServerSoftware",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/servers/{bootServerId}/update",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootServerId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/images` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_BOOT_IMAGES = {
    operationId: "listBootImages",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/images` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_BOOT_IMAGE = {
    operationId: "createBootImage",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_BOOT_IMAGE = {
    operationId: "updateBootImage",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/versions` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_BOOT_IMAGE_VERSIONS = {
    operationId: "listBootImageVersions",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/versions",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/restore` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESTORE_BOOT_IMAGE = {
    operationId: "restoreBootImage",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/restore",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/merge` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MERGE_BOOT_IMAGE = {
    operationId: "mergeBootImage",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/merge",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/prepare` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PREPARE_BOOT_IMAGE_VERSION = {
    operationId: "prepareBootImageVersion",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/prepare",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/make-independent` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MAKE_BOOT_IMAGE_INDEPENDENT = {
    operationId: "makeBootImageIndependent",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/make-independent",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/edits` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const START_BOOT_EDIT = {
    operationId: "startBootEdit",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/edits",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/server-edits` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const START_BOOT_SERVER_EDIT = {
    operationId: "startBootServerEdit",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/images/{imageId}/server-edits",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "imageId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/edits/{editId}/publish` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PUBLISH_BOOT_EDIT = {
    operationId: "publishBootEdit",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/edits/{editId}/publish",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "editId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/edits/{editId}/discard` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const DISCARD_BOOT_EDIT = {
    operationId: "discardBootEdit",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/edits/{editId}/discard",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "editId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/pcs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_BOOT_PCS = {
    operationId: "listBootPcs",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/pcs",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/pcs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const ADD_BOOT_PC = {
    operationId: "addBootPc",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/pcs",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/floor` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_BOOT_FLOOR = {
    operationId: "getBootFloor",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/floor",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/floor-states` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_BOOT_FLOOR_STATES = {
    operationId: "getBootFloorStates",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/floor-states",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/classes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_BOOT_CLASSES = {
    operationId: "listBootClasses",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/classes",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PUT /v1/organizations/{organizationId}/venues/{venueId}/boot/classes/{classId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_BOOT_CLASS = {
    operationId: "updateBootClass",
    method: "PUT",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/classes/{classId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "classId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/new-pcs` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_BOOT_NEW_PCS = {
    operationId: "listBootNewPcs",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/new-pcs",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `PATCH /v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const UPDATE_BOOT_PC = {
    operationId: "updateBootPc",
    method: "PATCH",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootPcId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/remove` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REMOVE_BOOT_PC = {
    operationId: "removeBootPc",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/remove",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootPcId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/identify` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const IDENTIFY_BOOT_PC = {
    operationId: "identifyBootPc",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/identify",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootPcId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/make-station` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const MAKE_BOOT_PC_STATION = {
    operationId: "makeBootPcStation",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/make-station",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootPcId"],
    headerParams: ["idempotency-key"],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/wipes` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const CREATE_BOOT_WIPE = {
    operationId: "createBootWipe",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/wipes",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/shader-seed` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PROMOTE_BOOT_SHADER_SEED = {
    operationId: "promoteBootShaderSeed",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/pcs/{bootPcId}/shader-seed",
    queryParams: [],
    pathParams: ["organizationId", "venueId", "bootPcId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/organizations/{organizationId}/venues/{venueId}/boot/rollouts/restart-idle` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const RESTART_IDLE_BOOT_PCS = {
    operationId: "restartIdleBootPcs",
    method: "POST",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/rollouts/restart-idle",
    queryParams: [],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/organizations/{organizationId}/venues/{venueId}/boot/metrics` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_BOOT_METRICS = {
    operationId: "getBootMetrics",
    method: "GET",
    path: "/v1/organizations/{organizationId}/venues/{venueId}/boot/metrics",
    queryParams: ["from", "to", "pc"],
    pathParams: ["organizationId", "venueId"],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/boot-servers/pair` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const PAIR_BOOT_SERVER = {
    operationId: "pairBootServer",
    method: "POST",
    path: "/v1/boot-servers/pair",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/boot-server/config` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_BOOT_SERVER_CONFIG = {
    operationId: "getBootServerConfig",
    method: "GET",
    path: "/v1/boot-server/config",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `GET /v1/hq/boot-server-releases` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const LIST_BOOT_SERVER_RELEASES = {
    operationId: "listBootServerReleases",
    method: "GET",
    path: "/v1/hq/boot-server-releases",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
/**
 * `POST /v1/hq/boot-server-releases` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const REGISTER_BOOT_SERVER_RELEASE = {
    operationId: "registerBootServerRelease",
    method: "POST",
    path: "/v1/hq/boot-server-releases",
    queryParams: [],
    pathParams: [],
    headerParams: [],
    hasBody: true,
};
/**
 * `PUT /v1/hq/boot-server-release-channels/{channel}` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const SET_BOOT_SERVER_RELEASE_CHANNEL = {
    operationId: "setBootServerReleaseChannel",
    method: "PUT",
    path: "/v1/hq/boot-server-release-channels/{channel}",
    queryParams: [],
    pathParams: ["channel"],
    headerParams: [],
    hasBody: true,
};
/**
 * `GET /v1/boot-server/release` — what the transport needs to send it.
 * The parameter lists are the contract's: sending a name that is not in one is a bug the client
 * refuses rather than a 400 from the server.
 */
export const GET_BOOT_SERVER_RELEASE = {
    operationId: "getBootServerRelease",
    method: "GET",
    path: "/v1/boot-server/release",
    queryParams: ["installedVersion"],
    pathParams: [],
    headerParams: [],
    hasBody: false,
};
//# sourceMappingURL=operations.js.map